import { Mousewheel } from 'swiper/modules';

window.monthNamesFullen = ["January", "February", "March", "April", "May", "June","July", "August", "September", "October", "November", "December"];
window.monthNamesFullid = ["Januari", "Februari", "Maret", "April", "Mei", "Juni", "Juli", "Agustus", "September", "Oktober", "November", "Desember"];
window.monthNamesen = ["Jan", "Feb", "Mar", "Apr", "May", "Jun","Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
window.monthNamesid = ["Jan", "Feb", "Mar", "Apr", "Mei", "Jun", "Jul", "Agu", "Sep", "Okt", "Nov", "Des"];

window.weekdayen = ["Sun","Mon","Tue","Wed","Thu","Fri","Sat"];
window.weekdayid = ["Min","Sen","Sel","Rab","Kam","Jum","Sab"];
window.weekdayFullen = ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];
window.weekdayFullid = ["Minggu","Senin","Selasa","Rabu","Kamis","Jumat","Sabtu"];


window.DaysMinsSecsAgoDefiner = function(value, whichone)
{
    let ToReturnValue = value + " " + window[whichone + window.CurrentCountryID];
    if(value > 1)
    {
        ToReturnValue = value + " " + window[whichone + "ex" + window.CurrentCountryID];
    }
    console.log(ToReturnValue);
    return ToReturnValue;
}

window.CurrentDisplayedDayEdit = null;
window.CurrentDisplayedMonthEdit = null;
window.CurrentDisplayedYearEdit = null;
window.CurrentSelectedDayEdit = null;
window.CurrentSelectedMonthEdit = null;
window.CurrentSelectedYearEdit = null;

window.WhichDateContainer = null;
window.WhichHowManyTextDisplayer = null;
window.OpposingContainer = "";
window.ThisStartEndType = null;
window.WhatDisplayFormat = null;
window.IsDateRemovable = null;
window.IsAllowSameDate = null;
window.DontAllowPastDate = null;

window.IsCalendarAnimating = false;

window.CurrentSelectedCheckIn = '';
window.CurrentSelectedCheckOut = '';
window.LimitCheckOut = '';


// =================================== DATE PICKER =======================================

window.OpenDateChoiceContainer = function(whichdatecontainerid, opposingcontainerid, togglearrowid, startendingtype, howmanynighttextid, whichdisplayformat, isremovable, allowsamedate, dontallowpastdate, instiateatleft, allowcheckinavailability, isallinonechoice, functiontocall)
{
    window.event.preventDefault();
    window.event.stopPropagation();

    window.RotateToggle(togglearrowid, true);

    window.IsCalendarAnimating = false;
    window.CurrentCheckedExistData = {};


    window.WhichDateContainer = document.getElementById(whichdatecontainerid);

    let ThisDropDownContainer = window.FunctionCheckInstantiateDropDown("WhitePanelContentContainer" + whichdatecontainerid, window.WhichDateContainer);

    if(ThisDropDownContainer == null)
        return

    ThisDropDownContainer.className = "ContainerFlex";
    ThisDropDownContainer.style.bottom = 0;
    ThisDropDownContainer.innerHTML = "";

    // ----------------------------- PREPARATION -----------------------------

    window.WhichHowManyTextDisplayer = null;
    if(howmanynighttextid != "")
        window.WhichHowManyTextDisplayer = document.getElementById(howmanynighttextid);

    window.CurrentDisplayedDayEdit = parseInt(window.WhichDateContainer.getAttribute("date"));
    window.CurrentDisplayedMonthEdit = parseInt(window.WhichDateContainer.getAttribute("month"));
    window.CurrentDisplayedYearEdit = parseInt(window.WhichDateContainer.getAttribute("year"));

    window.CurrentSelectedDayEdit = window.CurrentDisplayedDayEdit;
    window.CurrentSelectedMonthEdit = window.CurrentDisplayedMonthEdit;
    window.CurrentSelectedYearEdit = window.CurrentDisplayedYearEdit;

    window.OpposingContainer = "";
    if(opposingcontainerid != "")
    {
        window.OpposingContainer = document.getElementById(opposingcontainerid);
    }

    window.CurrentSelectedCheckIn = '';
    window.CurrentSelectedCheckOut = '';

    window.ThisStartEndType = startendingtype;
    window.WhatDisplayFormat = whichdisplayformat;
    window.IsDateRemovable = isremovable;
    window.IsAllowSameDate = allowsamedate;
    window.DontAllowPastDate = dontallowpastdate;


    if(window.ThisRoomData != null &&  window.ThisRoomData.book_type == "per day")
        isallinonechoice = false;

    if(isallinonechoice == true && window.OpposingContainer != "")
    {
        let ThisMainContainerFullDate = new Date(window.CurrentSelectedYearEdit, (window.CurrentSelectedMonthEdit - 1), window.CurrentSelectedDayEdit);

        let OpposingContainerDay = parseInt(window.OpposingContainer.getAttribute("date"));
        let OpposingContainerMonth = parseInt(window.OpposingContainer.getAttribute("month"));
        let OpposingContainerYear = parseInt(window.OpposingContainer.getAttribute("year"));

        let OpposingContainerFullDate = new Date(OpposingContainerYear, (OpposingContainerMonth - 1), OpposingContainerDay);

        if(window.ThisStartEndType == "Start")
        {
            window.CurrentSelectedCheckIn = ThisMainContainerFullDate;
            window.CurrentSelectedCheckOut = OpposingContainerFullDate;
        }
        else
        {
            window.CurrentSelectedCheckOut = ThisMainContainerFullDate;
            window.CurrentSelectedCheckIn = OpposingContainerFullDate;
        }
    }

    // const thisdate = new Date(window.CurrentDisplayedYearEdit, window.CurrentDisplayedMonthEdit-1, window.CurrentDisplayedDayEdit);

    // ----------------------------- INSTANTIATE CALENDAR -----------------------------

    let WhitePanelContentContainer = document.createElement("div");
    WhitePanelContentContainer.className = "WhitePanelContentContainer BasicRadius";
    WhitePanelContentContainer.id = "WhitePanelContentContainer" + whichdatecontainerid;
    WhitePanelContentContainer.style.top = 0;
    if(instiateatleft == true)
    {
        WhitePanelContentContainer.style.left = 0;
    }
    else
    {
        WhitePanelContentContainer.style.right = 0;
    }
    ThisDropDownContainer.append(WhitePanelContentContainer);
    // window.PanelChoiceOpen.style.top = window.WhichDateContainer.getBoundingClientRect().bottom + window.scrollY + 5;
    // window.PanelChoiceOpen.style.left = window.WhichDateContainer.getBoundingClientRect().left + window.scrollX - 0;
    // document.getElementsByTagName("body")[0].append(window.PanelChoiceOpen);

    let DatePickerHeader = document.createElement("div");
    DatePickerHeader.className = "DatePickerHeader";
    WhitePanelContentContainer.append(DatePickerHeader);

    let CurrentMonthandYear = document.createElement("p");
    CurrentMonthandYear.className = "CurrentMonthandYear InterBoldTextFont Selectable2";
    CurrentMonthandYear.id = "CurrentMonthandYearToEdit";
    CurrentMonthandYear.innerHTML = window["monthNamesFull" + window.CurrentCountryID][window.CurrentDisplayedMonthEdit - 1] + " " + window.CurrentDisplayedYearEdit;
    DatePickerHeader.append(CurrentMonthandYear);

    let MonthButtonContainer = document.createElement("div");
    MonthButtonContainer.className = "MonthButtonContainer";
    DatePickerHeader.append(MonthButtonContainer);

    let PreviousMonthButton = document.createElement("img");
    PreviousMonthButton.className = "PreviousMonthButton Selectable2";
    PreviousMonthButton.src = "/Assets/images/ButtonIcon/chevron.svg";
    PreviousMonthButton.id = "PreviousMonthButton";
    MonthButtonContainer.append(PreviousMonthButton);

    let NextMonthButton = document.createElement("img");
    NextMonthButton.className = "NextMonthButton Selectable2";
    NextMonthButton.src = "/Assets/images/ButtonIcon/chevron.svg";
    NextMonthButton.id = "NextMonthButton";
    MonthButtonContainer.append(NextMonthButton);

    let DatePickerDateTable = document.createElement("div");
    DatePickerDateTable.className = "DatePickerDateTable";
    WhitePanelContentContainer.append(DatePickerDateTable);

    let CurrentMonthTable = document.createElement("table");
    CurrentMonthTable.className = "CurrentMonthTable";
    DatePickerDateTable.append(CurrentMonthTable);

    let TheadCalendarHeader = document.createElement("thead");
    TheadCalendarHeader.className = "TheadCalendarHeader InterBoldTextFont";
    CurrentMonthTable.append(TheadCalendarHeader);

    let TrCalendarHeader = document.createElement("tr");
    TrCalendarHeader.className = "TrCalendarHeader";
    TheadCalendarHeader.append(TrCalendarHeader);

    for(let i = 0; i < window["weekday" + window.CurrentCountryID].length; i++)
    {
        let HeaderDays = document.createElement("th");
        HeaderDays.className = "HeaderDays";
        if(i == 0 || i == 6)
        {
            HeaderDays.className = "HeaderDaysHoliday";
        }
        HeaderDays.innerHTML = window["weekday" + window.CurrentCountryID][i];
        TrCalendarHeader.append(HeaderDays);
    }

    var TBodyCalendar = document.createElement("tbody");
    TBodyCalendar.className = "TBodyCalendar InterRegularTextFont";
    TBodyCalendar.id = "TBodyCalendar";
    CurrentMonthTable.append(TBodyCalendar);


    let ApplyButtonContainer = document.createElement("div");
    ApplyButtonContainer.className = "ApplyButtonContainer";
    WhitePanelContentContainer.append(ApplyButtonContainer);

        
    let ApplyMonthButton = document.createElement("button");
    ApplyMonthButton.className = "ApplyMonthButton BasicRadius Selectable";
    if(allowcheckinavailability == true)
        ApplyMonthButton.className = "ApplyMonthButton BasicRadius ButtonInvalid";
    ApplyMonthButton.innerHTML = window["ApplyTxt" + window.CurrentCountryID];
    ApplyButtonContainer.append(ApplyMonthButton);

    window.NextDateOrPastChange(0, PreviousMonthButton, CurrentMonthandYear, allowcheckinavailability, 0, isallinonechoice, ApplyMonthButton);


    // Add Function ---------------------------------------------------------------------------------

    WhitePanelContentContainer.onclick = function(event)
    {
        event.preventDefault();
        event.stopPropagation();
    }

    CurrentMonthandYear.onclick = function()
    {
        window.OpenMonthChoiceDropDown(allowcheckinavailability, isallinonechoice, ApplyMonthButton);
    }

    PreviousMonthButton.onclick = function()
    {
        window.NextDateOrPastChange(-1, PreviousMonthButton, CurrentMonthandYear, allowcheckinavailability, 100, isallinonechoice, ApplyMonthButton);
    }
    NextMonthButton.onclick = function()
    {
        window.NextDateOrPastChange(1, PreviousMonthButton, CurrentMonthandYear, allowcheckinavailability, 100, isallinonechoice, ApplyMonthButton);
    }

    ApplyMonthButton.onclick = function()
    {
        window.ApplyDateChanges(ThisDropDownContainer, whichdatecontainerid, opposingcontainerid, functiontocall, isallinonechoice);
    }

    // Apply Check if Overflow Function to Panel -----------------------------------------------------
        
    function adjustPanelPosition()
    {
        // Stop executing if the element was removed from the DOM
        if (!document.getElementById(WhitePanelContentContainer.id)) return;

        let rect = WhitePanelContentContainer.getBoundingClientRect();

        // Case 1: Elements aligned to the left that spill over the right screen edge
        if (rect.right > window.innerWidth)
        {
            WhitePanelContentContainer.style.left = "auto";
            WhitePanelContentContainer.style.right = "0px";
        } 
        // Case 2: Elements aligned to the right that spill over the left screen edge
        else if (rect.left < 0)
        {
            WhitePanelContentContainer.style.right = "auto";
            WhitePanelContentContainer.style.left = "0px";
        }
    }

    // Run immediately on creation
    adjustPanelPosition();

    // Attach listeners for dynamic updates
    window.addEventListener("resize", adjustPanelPosition);
    window.addEventListener("scroll", adjustPanelPosition, true);
}

window.InstantiateDatesInsideContainer = function(CurrentMonthandYear, durationtransition, allowcheckinavailability, isallinonechoice, ApplyMonthButton)
{
    let BodyCalendarToInstantiate = document.getElementById("TBodyCalendar");
    CurrentMonthandYear.innerHTML = window["monthNamesFull" + window.CurrentCountryID][window.CurrentDisplayedMonthEdit - 1] + " " + window.CurrentDisplayedYearEdit;

    if(window.IsCalendarAnimating == false)
    {
        window.IsCalendarAnimating = true;
        
        if(durationtransition != 0)
        {
            BodyCalendarToInstantiate.style.opacity = "0";
            BodyCalendarToInstantiate.animate([{opacity: '1'},{opacity: '0'}], {duration: durationtransition});
        }
        
        setTimeout(function()
        {
            BodyCalendarToInstantiate.innerHTML = "";
    
            // Current Selected Date -------
            let CurrentSelectedFullDate = new Date(window.CurrentSelectedYearEdit, window.CurrentSelectedMonthEdit-1, window.CurrentSelectedDayEdit);
            
            // Get Today Date -------
            let WhatDayIsToday = window.GetAndConvertCurrentDate(false);
        
            // Get Today Date -------
            let OpposingDate = null;
            if(window.OpposingContainer != "")
            {
                let OpposingDay = window.OpposingContainer.getAttribute("date");
                let OpposingMonth = window.OpposingContainer.getAttribute("month");
                let OpposingYear = window.OpposingContainer.getAttribute("year");
        
                if(OpposingDay != null && OpposingMonth != null && OpposingYear != null)
                {
                    OpposingDate = new Date(parseInt(OpposingYear), parseInt(OpposingMonth)-1, parseInt(OpposingDay));
                }
            }
            
        
            // Instantiate Past Date ---------------------------------------
            
            let StartDateofCurrentDate = new Date(window.CurrentDisplayedYearEdit, window.CurrentDisplayedMonthEdit-1, 1);
            let WhichDayNumberStart = StartDateofCurrentDate.getDay();
        
            let TrCalendarBody = document.createElement("tr");
            TrCalendarBody.className = "TrCalendarBody";
            BodyCalendarToInstantiate.append(TrCalendarBody);
        
            for(let i = 0; i < WhichDayNumberStart; i++)
            {
                let DateButton = document.createElement("td");
                DateButton.className = "DateButton";
                TrCalendarBody.append(DateButton);
            }
        
            // Instantiate Current Date ---------------------------------------
        
            let i = 0;
            let HowManyDayThisMonth = new Date(window.CurrentDisplayedYearEdit, window.CurrentDisplayedMonthEdit, 0).getDate();
            let DateButtonsList = [];

            while (i < HowManyDayThisMonth)
            {
                let CurrentDisplayedDate = new Date(window.CurrentDisplayedYearEdit, window.CurrentDisplayedMonthEdit-1, i+1);
                let ThisDateDayNumber = CurrentDisplayedDate.getDay();
        
                if(ThisDateDayNumber == 0)
                {
                    TrCalendarBody = document.createElement("tr");
                    TrCalendarBody.className = "TrCalendarBody";
                    BodyCalendarToInstantiate.append(TrCalendarBody);
                }
        
                let DateButton = document.createElement("td");
                DateButton.className = "DateButton Selectable";
                DateButton.setAttribute("date", i+1);
                DateButton.setAttribute("month", window.CurrentDisplayedMonthEdit);
                DateButton.setAttribute("year", window.CurrentDisplayedYearEdit);
                DateButton.onclick = function(event)
                {
                    event.preventDefault();
                    event.stopPropagation();
        
                    window.ThisCalendarDateButtonSelected(DateButton, isallinonechoice, ()=>window.InstantiateDatesInsideContainer(CurrentMonthandYear, 0, false, isallinonechoice, ApplyMonthButton));
                }
                TrCalendarBody.append(DateButton);

        
                let DateButtonText = document.createElement("p");
                DateButtonText.innerHTML = (i+1);
                DateButton.append(DateButtonText);
        
                if(window.ThisStartEndType == "End" && OpposingDate != null)
                {
                    if(CurrentDisplayedDate.getTime() < OpposingDate.getTime() || (CurrentDisplayedDate.getTime() == OpposingDate.getTime() && window.IsAllowSameDate == false) && isallinonechoice == false)
                    {
                        DateButton.classList.add("DateButtonInvalid");
                    }
                }
        
                if(window.DontAllowPastDate == true && CurrentDisplayedDate.getTime() < WhatDayIsToday.getTime())
                {
                    DateButton.classList.add("DateButtonInvalid");
                }

                // if(allowcheckinavailability == true) // If Checking Availability True ----------------------------
                // {
                //     DateButton.style.opacity = "0";
                //     DateButton.style.pointerEvents = "none";
                // }
                DateButtonsList.push(DateButton);

                // Apply Class Based ON Status ------------------------------------------------------------

                if(isallinonechoice == false && CurrentSelectedFullDate.getTime() == CurrentDisplayedDate.getTime())
                {
                    DateButton.classList.add("CurrentSelectedDate");
                }
                else if(isallinonechoice == true && window.CurrentSelectedCheckIn != '')
                {
                    if(CurrentDisplayedDate.getTime() == window.CurrentSelectedCheckIn.getTime())
                    {
                        if(window.CurrentSelectedCheckOut == '')
                        {
                            DateButton.classList.add("CalendarCurrentOnlyThisDate");
                        }
                        else
                        {
                            DateButton.classList.add("CalendarCurrentStartDate");
                        }
                    }
                    else if(window.CurrentSelectedCheckOut != '')
                    {
                        if(CurrentDisplayedDate.getTime() > window.CurrentSelectedCheckIn.getTime() && CurrentDisplayedDate.getTime() < window.CurrentSelectedCheckOut.getTime())
                        {
                            DateButton.classList.add("CalendarCurrentMidDate");
                        }
                        else if(CurrentDisplayedDate.getTime() == window.CurrentSelectedCheckOut.getTime())
                        {
                            DateButton.classList.add("CalendarCurrentEndDate");
                        }
                    }
                }
                else if(WhatDayIsToday.getTime() == CurrentDisplayedDate.getTime())
                {
                    DateButton.classList.add("ThisCurrentDate");
                }
            
                i++;
            }

            // Checking Exist Room -----------------------------------------------
            if(allowcheckinavailability == true)
            {
                window.CurrentCheckedExistData = {};

                let ThisLoading = window.InstantiateLoadingCircle(BodyCalendarToInstantiate, true);
                window.CheckWhichDateExist(window.CurrentDisplayedMonthEdit, window.CurrentDisplayedYearEdit, DateButtonsList, ThisLoading, isallinonechoice, ApplyMonthButton, null);
            }
            else
            {
                window.CheckAndApplyDateButtonAvailability(DateButtonsList, isallinonechoice, false, ApplyMonthButton);
            }

            BodyCalendarToInstantiate.animate([{opacity: '0'},{opacity: '1'}], {duration: durationtransition});
            setTimeout(function()
            {
                BodyCalendarToInstantiate.style.opacity = "1";
                window.IsCalendarAnimating = false;

            }, durationtransition);

        }, durationtransition);
    }
}


// =================================== DATE PICKER (MOBILE) ========================================


window.InstantiateDateChoiceMobilePanel = function(functiontocallwhensaving, functiontocallonclose, isdirect, isallowmorethanone)
{
    window.CurrentCheckedExistData = {};
    window.CurrentLoadingMonthAvailability = {};

    console.log("CALLED window.InstantiateDateChoiceMobilePanel");

    if(window.ThisRoomData == null)
    {
        const RoomHotelContainer = document.getElementById("ChangeRoomContainerHotelDetailsMobile");
        window.ScrollToWindow(RoomHotelContainer);
        window.DisplayWarningPopUp("WarningPanelFailed WarningFailedAlert", window["PleaseSelectARoomOrItemFirstTxt" + window.CurrentCountryID]);
        return
    }

    // Early Setup -----------------------------------------------------------

    window.CurrentSelectedCheckIn = '';
    window.CurrentSelectedCheckOut = '';

    console.log("window.CheckInDateNonTop", window.CheckInDateNonTop);
    
    if(window.CheckInDateNonTop != null)
    {
        let MobileCheckInArray = window.CheckInDateNonTop.split("-");
        let ThisCheckInDate = new Date(MobileCheckInArray[0], parseInt(MobileCheckInArray[1] - 1), MobileCheckInArray[2]);

        window.CurrentSelectedCheckIn = ThisCheckInDate;
    }

    if(window.CheckOutDateNonTop != null)
    {
        let MobileCheckOutArray = window.CheckOutDateNonTop.split("-");
        let ThisCheckOutDate = new Date(MobileCheckOutArray[0], parseInt(MobileCheckOutArray[1] - 1), MobileCheckOutArray[2]);
            
        window.CurrentSelectedCheckOut = ThisCheckOutDate;
    }

    console.log("window.CurrentSelectedCheckIn", window.CurrentSelectedCheckIn);

    window.CurrentSelectedDayEdit = window.CurrentSelectedCheckIn.getDate();
    window.CurrentSelectedMonthEdit = window.CurrentSelectedCheckIn.getMonth()+1;
    window.CurrentSelectedYearEdit = window.CurrentSelectedCheckIn.getFullYear();
    

    // Instantiate -----------------------------------------------------------

    let BasicBlackBlocker = document.createElement("div");
    BasicBlackBlocker.className = "BasicBlackBlocker ResponsiveMobilePanel";
    BasicBlackBlocker.OnResponsiveRemove = function()
    {
        if(functiontocallonclose != null && isdirect == true)
            functiontocallonclose();
    };
    document.getElementsByTagName("body")[0].append(BasicBlackBlocker);

    let FlexContainerWithTopPanel = document.createElement("div");
    FlexContainerWithTopPanel.className = "FlexFullDisplayPanel FlexPanelOnlyForMobile";
    FlexContainerWithTopPanel.style.padding = "0px";
    BasicBlackBlocker.append(FlexContainerWithTopPanel);

    let TopBarContainer = document.createElement("div"); // Top Bar Container ------------------------------------
    TopBarContainer.className = "TopBottomHeaderButtonPaddingContainer BasicBoxShadowMid";
    TopBarContainer.style.flexDirection = "column";
    FlexContainerWithTopPanel.append(TopBarContainer);

    
    let WhichRoomDataToUsed = window.ThisRoomData;
        
    if(WhichRoomDataToUsed.min_booking_notice_days != null && WhichRoomDataToUsed.min_booking_notice_days > 0)
    {
        let ContainerWarningBookingAtLeast = document.createElement("div"); // Top Warning Text ------------------------------------
        ContainerWarningBookingAtLeast.className = "ContainerWithIconAndText BasicRadius InputFieldMargin3";
        ContainerWarningBookingAtLeast.style.backgroundColor = "#FFFAEB";
        ContainerWarningBookingAtLeast.flexDirection = "column";
        TopBarContainer.append(ContainerWarningBookingAtLeast);

        let WarningBookingAtLeastText = document.createElement("p"); 
        WarningBookingAtLeastText.className = "LabelGreyHeaderSmallerText2 InterMediumTextFont";
        WarningBookingAtLeastText.style.margin = "auto 0";
        WarningBookingAtLeastText.style.color = "#344054";
        WarningBookingAtLeastText.innerHTML = window.MinRangeTextLeft(WhichRoomDataToUsed.min_booking_notice_days);
        ContainerWarningBookingAtLeast.append(WarningBookingAtLeastText);
    }

    let TopHeaderContentWrapper = document.createElement("div"); // Main Header Top ------------------------------------
    TopHeaderContentWrapper.className = "ColumnGapExtraLong";
    TopHeaderContentWrapper.style.flex = 1;
    TopHeaderContentWrapper.style.height = "fit-content";
    TopHeaderContentWrapper.style.display = "flex";
    TopHeaderContentWrapper.style.position = "relative";
    TopBarContainer.append(TopHeaderContentWrapper)

    let TopPrevButton = document.createElement("img");
    TopPrevButton.className = "BasicInputFieldChevronIconSearch Selectable2";
    TopPrevButton.style.margin = "auto 0";
    TopPrevButton.style.rotate = "90deg";
    TopPrevButton.src = "/Assets/images/ButtonIcon/chevron.svg";
    TopHeaderContentWrapper.append(TopPrevButton)

    let TopHeaderText = document.createElement("p");
    TopHeaderText.className = "PaymentPriceFinalToPay MarginTextUpDown InterBoldTextFont";
    TopHeaderText.style.margin = "auto 0";
    TopHeaderText.innerHTML = window["ChangeDateSettingsTxt" + window.CurrentCountryID];
    TopHeaderContentWrapper.append(TopHeaderText)

    let TopCloseButton = document.createElement("img");
    TopCloseButton.className = "CloseButtonInsidePanel Selectable2";
    TopCloseButton.style.position = "absolute";
    TopCloseButton.style.right = "0";
    TopCloseButton.style.top = "50%";
    TopCloseButton.style.transform = "translateY(-50%)";
    TopCloseButton.src = "/Assets/images/ButtonIcon/cancel-x-grey.svg";
    TopHeaderContentWrapper.append(TopCloseButton)
    


    let MobileCalendarSwiperContainer = document.createElement("div"); // Date Container ------------------------------------
    MobileCalendarSwiperContainer.className = "MobileCalendarSwiperContainer BasicGradientTopBottomMask";
    FlexContainerWithTopPanel.append(MobileCalendarSwiperContainer);

    let MobileCalendarSwiper = document.createElement("div");
    MobileCalendarSwiper.className = "swiper MobileCalendarSwiper";
    MobileCalendarSwiperContainer.append(MobileCalendarSwiper);

    let MobileCalendarSwiperWrapper = document.createElement("div");
    MobileCalendarSwiperWrapper.className = "swiper-wrapper";
    MobileCalendarSwiper.append(MobileCalendarSwiperWrapper);

    
    let BottomMainContainer = document.createElement("div"); // Date Bottom Check In Out Button ------------------------------------
    BottomMainContainer.className = "TopBottomHeaderButtonPaddingContainer BasicBoxShadowUp RowGapBasic2";
    BottomMainContainer.style.flexDirection = "column";
    FlexContainerWithTopPanel.append(BottomMainContainer);

    let BottomCheckInOutWrapper = document.createElement("div"); //Check In Out ---------------
    BottomCheckInOutWrapper.className = "HotelDetailsHotelInformationMarginWrapper";
    BottomCheckInOutWrapper.style.flex = 1;
    BottomCheckInOutWrapper.style.height = "fit-content";
    BottomCheckInOutWrapper.style.display = "flex";
    BottomCheckInOutWrapper.style.position = "relative"
    BottomMainContainer.append(BottomCheckInOutWrapper);

    let CheckInWrapper = document.createElement("div"); // Check In
    BottomCheckInOutWrapper.append(CheckInWrapper);

    let CheckInHeaderText = document.createElement("p");
    CheckInHeaderText.className = "BasicInputTextTop InterBoldTextFont";
    CheckInHeaderText.innerHTML = window["CheckInTxt" + window.CurrentCountryID];
    CheckInWrapper.append(CheckInHeaderText);

    let CheckInDateText = document.createElement("p");
    CheckInDateText.className = "PaymentPriceFinalToPay InterMediumTextFont";
    CheckInDateText.style.marginBottom = "0";
    CheckInDateText.style.color = "#2494D9";
    CheckInDateText.innerHTML = "-- --- ----";
    CheckInWrapper.append(CheckInDateText);

    
    let HowManyNightsAndLineWrapper = document.createElement("div"); // How Many Nights
    HowManyNightsAndLineWrapper.className = "BluDotWrapper TextToDisplayAfterCalc RowGapBasic";
    HowManyNightsAndLineWrapper.style.width = "auto";
    HowManyNightsAndLineWrapper.style.flex = 1;
    HowManyNightsAndLineWrapper.style.display = "flex";
    HowManyNightsAndLineWrapper.style.flexDirection = "column";
    BottomCheckInOutWrapper.append(HowManyNightsAndLineWrapper);

    let BlueNightDotLine = document.createElement("div");
    BlueNightDotLine.className = "BlueNightDotLine";
    BlueNightDotLine.style.width = "100%";
    HowManyNightsAndLineWrapper.append(BlueNightDotLine);

    let HowManyNightsText = document.createElement("p");
    HowManyNightsText.className = "BasicInputTextTop InterRegularTextFont HowManyNightText";
    HowManyNightsText.style.margin = "0 auto";
    HowManyNightsText.innerHTML = "-- Night";
    HowManyNightsAndLineWrapper.append(HowManyNightsText);
    
    let CheckOutWrapper = document.createElement("div"); // Check Out
    BottomCheckInOutWrapper.append(CheckOutWrapper);

    let CheckOutHeaderText = document.createElement("p");
    CheckOutHeaderText.className = "BasicInputTextTop InterBoldTextFont";
    CheckOutHeaderText.innerHTML = window["CheckOutTxt" + window.CurrentCountryID];
    CheckOutWrapper.append(CheckOutHeaderText);

    let CheckOutDateText = document.createElement("p");
    CheckOutDateText.className = "PaymentPriceFinalToPay InterMediumTextFont";
    CheckOutDateText.style.marginBottom = "0";
    CheckOutDateText.style.color = "#D92D20";
    CheckOutDateText.innerHTML = "Select Check-out Date";
    CheckOutWrapper.append(CheckOutDateText);


    if(WhichRoomDataToUsed.book_type == "per day")
    {
        CheckInHeaderText.innerHTML = window["DateOfVisitTxt" + window.CurrentCountryID];
        HowManyNightsAndLineWrapper.style.display = "none";
        CheckOutWrapper.style.display = "none";
    }

    
    let SaveButton = document.createElement("button"); // Save Button ---------------
    SaveButton.className = "ApplyMonthButton BasicRadius ButtonInvalid";
    SaveButton.style.margin = 0;
    SaveButton.style.width = "100%";
    BottomMainContainer.append(SaveButton);

    let SaveButtonText = document.createElement("p");
    SaveButtonText.className = "InterMediumTextFont PaymentPriceFinalToPay ";
    SaveButtonText.innerHTML = window["SavedButtonTxt" + window.CurrentCountryID];
    SaveButtonText.style.margin = "auto";
    SaveButton.append(SaveButtonText);

    let ThisSwiper = new window.Swiper(MobileCalendarSwiper,
    {
        modules: [Mousewheel],
        direction: 'vertical',
        autoHeight: false,
        slidesPerView: 1,
        // spaceBetween: 16,
        mousewheel: true,
        grabCursor: true,
    });

    let ClosePanelFunction = function(isjustclose)
    {
        if(functiontocallwhensaving != null && isjustclose == false) // If Just Close Then don't call any function assigned
            functiontocallwhensaving();
        
        window.ClosePanelAnimate(FlexContainerWithTopPanel, BasicBlackBlocker, null);
    }

    let CloseWithoutSavingFunction = function()
    {
        functiontocallonclose();

        ClosePanelFunction(true);
    }

    TopPrevButton.onclick = function()
    {
        CloseWithoutSavingFunction();
    }

    TopCloseButton.onclick = function()
    {
        CloseWithoutSavingFunction();
    }

    if(isdirect == true)
    {
        TopPrevButton.style.display = "none";
    }
    else
    {
        TopCloseButton.style.display = "none";
    }

    PrepareInstantiateCalendarTableMobile(isallowmorethanone, MobileCalendarSwiperWrapper, CheckInDateText, HowManyNightsText, CheckOutDateText, SaveButton, ()=>ClosePanelFunction(false), ThisSwiper, WhichRoomDataToUsed);

    window.OpenPanelAnimate(FlexContainerWithTopPanel, BasicBlackBlocker);
}

function PrepareInstantiateCalendarTableMobile(isallowmorethanone, MobileCalendarSwiperWrapper, CheckInDateText, HowManyNightsText, CheckOutDateText, SaveButton, ClosePanelFunction, ThisSwiper, WhichRoomDataToUsed)
{
    let TodayDate = window.GetAndConvertCurrentExactDate(false);
    let TodayMonth = TodayDate.getMonth();
    let TodayYear = TodayDate.getFullYear();

    let CheckOutDate = TodayDate;
    if(window.CurrentSelectedCheckOut != '')
    {
        CheckOutDate = window.CurrentSelectedCheckOut;
    }

    let MonthDifference = window.getCalendarMonthDiff(TodayDate, CheckOutDate);


    let FunctionTocall = function()
    {
        CheckAndUpdateMobileCalendar(CheckInDateText, HowManyNightsText, CheckOutDateText, MobileCalendarSwiperWrapper, SaveButton, ClosePanelFunction, isallowmorethanone, WhichRoomDataToUsed);
    }


    for(let i = 0; i < (MonthDifference + 2); i++)
    {
        let ThisDateToInstantiate = new Date(TodayYear, (TodayMonth + 1 + i), 0);
        InstantiateCalendarTableMobile(ThisDateToInstantiate, MobileCalendarSwiperWrapper, ()=>FunctionTocall(), SaveButton, isallowmorethanone);
    }

    ThisSwiper.on('reachEnd', function ()
    {
        let ThisTableContainerNow = MobileCalendarSwiperWrapper.querySelectorAll(".ThisCalendarTable");
        let ThisDateToInstantiate = new Date(TodayYear, (TodayMonth + 1 + ThisTableContainerNow.length), 0);
        InstantiateCalendarTableMobile(ThisDateToInstantiate, MobileCalendarSwiperWrapper, ()=>FunctionTocall(), SaveButton, isallowmorethanone);
        ThisSwiper.update();
    });
}

function InstantiateCalendarTableMobile(thisdate, Parent, functiontocall, SaveButton, isallowmorethanone)
{
    let ThisDateCellsData = window.PreparePrevCurrentNextMonthCalendarInfo(thisdate.getFullYear(), thisdate.getMonth() + 1, isallowmorethanone);
    

    let CalendarSwiperSlide = document.createElement("div");
    CalendarSwiperSlide.className = "swiper-slide ThisCalendarTable";
    CalendarSwiperSlide.style.height = "auto";
    Parent.append(CalendarSwiperSlide);

    let MonthTitle = document.createElement("p");
    MonthTitle.className = "RoomHotelNameInsidePanel InterBoldTextFont HotelDetailsHotelInformationMarginWrapper";
    MonthTitle.style.textAlign = "center";
    MonthTitle.style.marginLeft = "auto";
    MonthTitle.style.marginRight = "auto";
    MonthTitle.style.width = "fit-content";
    MonthTitle.innerText = window["monthNamesFull" + window.CurrentCountryID][parseInt(thisdate.getMonth())] + " " + thisdate.getFullYear();
    CalendarSwiperSlide.append(MonthTitle);

    let DatePickerTable = document.createElement("div");
    DatePickerTable.className = "DatePickerDateTable";
    DatePickerTable.style.width = "auto";
    CalendarSwiperSlide.append(DatePickerTable);

    let CurrentMonthTable = document.createElement("table");
    CurrentMonthTable.className = "CurrentMonthTable";
    CurrentMonthTable.style.width = "100%";
    CurrentMonthTable.style.borderCollapse = "collapse";
    DatePickerTable.append(CurrentMonthTable);

    let TheadCalendarHeader = document.createElement("thead"); // Table Header -------------
    TheadCalendarHeader.className = "TheadCalendarHeader InterBoldTextFont";
    CurrentMonthTable.append(TheadCalendarHeader);

    let TrCalendarHeader = document.createElement("tr");
    TrCalendarHeader.className = "TrCalendarHeader";
    TheadCalendarHeader.append(TrCalendarHeader);

    for(let i = 0; i < window["weekday" + window.CurrentCountryID].length; i++)
    {
        let HeaderDays = document.createElement("th");
        HeaderDays.className = "HeaderDays";
        
        if(i == 0 || i == 6)
        {
            HeaderDays.className = "HeaderDaysHoliday";
        }
        HeaderDays.innerHTML = window["weekday" + window.CurrentCountryID][i];
        TrCalendarHeader.append(HeaderDays);
    }

    let TBodyCalendar = document.createElement("tbody"); // Table Body -------------
    TBodyCalendar.className = "TBodyCalendar InterRegularTextFont";
    CurrentMonthTable.append(TBodyCalendar);

    let HowManyInstantiated = 0;
    let CalendarBodyToInstantiate = null;
    let ThisDateButtonArray = [];
    let TodayDate = window.GetAndConvertCurrentExactDate(false);
    TodayDate = new Date(TodayDate.getFullYear(), TodayDate.getMonth(), TodayDate.getDate());

    for(let i = 0; i < ThisDateCellsData.length; i++)
    {
        if(HowManyInstantiated == 0)
        {
            CalendarBodyToInstantiate = document.createElement("tr");
            CalendarBodyToInstantiate.className = "TrCalendarBody";
            TBodyCalendar.append(CalendarBodyToInstantiate);
        }
        
        let ThisCalendarButton = document.createElement("td");
        ThisCalendarButton.className = "DateButton Selectable";
        ThisCalendarButton.setAttribute("What-date", ThisDateCellsData[i].date);
        ThisDateButtonArray.push(ThisCalendarButton);

        if(TodayDate.getTime() > ThisDateCellsData[i].datevalue.getTime() || ThisDateCellsData[i].isOtherMonth == true)
        {
            ThisCalendarButton.classList.add("DateButtonInvalid");

            if(ThisDateCellsData[i].isOtherMonth == true)
                ThisCalendarButton.style.opacity = "10%";
        }
        else
        {
            ThisCalendarButton.onclick = function()
            {
                window.ThisCalendarDateButtonSelected(ThisCalendarButton, isallowmorethanone, functiontocall);
            }
        }

        if(TodayDate.getTime() == ThisDateCellsData[i].datevalue.getTime())
        {
            ThisCalendarButton.classList.add("ThisCurrentDate");
        }

        ThisCalendarButton.setAttribute("original-class", ThisCalendarButton.className);

        CalendarBodyToInstantiate.append(ThisCalendarButton);
        
        let ThisCalendarButtonText = document.createElement("p");
        ThisCalendarButtonText.innerHTML = ThisDateCellsData[i].day;
        ThisCalendarButton.append(ThisCalendarButtonText);

        HowManyInstantiated++
        
        if(HowManyInstantiated >= 7)
            HowManyInstantiated = 0;
    }

    let ThisLoading = window.InstantiateLoadingCircle(CalendarSwiperSlide, true);
    window.CheckWhichDateExist(thisdate.getMonth() + 1, thisdate.getFullYear(), ThisDateButtonArray, ThisLoading, isallowmorethanone, SaveButton, functiontocall);

    if(functiontocall != null)
    functiontocall();
}


function CheckAndUpdateMobileCalendar(CheckInDateText, HowManyNightsText, CheckOutDateText, tablecontainer, SaveButton, ClosePanelFunction, isallowmorethanone, WhichRoomDataToUsed)
{
    let IsInputtedFalse = false;


    if(WhichRoomDataToUsed.book_type == "per night")
    {
        if(window.CurrentSelectedCheckIn != '')
        {
            let ThisCheckInDay = window.CurrentSelectedCheckIn.getDate();
            let ThisCheckInMonth = window.CurrentSelectedCheckIn.getMonth();
            let ThisCheckInYear = window.CurrentSelectedCheckIn.getFullYear();

            CheckInDateText.style.color = "#2494D9";
            CheckInDateText.innerHTML = ThisCheckInDay + " " + window["monthNames" + window.CurrentCountryID][ThisCheckInMonth] + " " + ThisCheckInYear;
        }
        else
        {
            CheckInDateText.style.color = "#D92D20";
            CheckInDateText.innerHTML = window["SelectCheckInTxt" + window.CurrentCountryID];

            IsInputtedFalse = true;
        }

        if(window.CurrentSelectedCheckOut != '')
        {
            let ThisCheckOutDay = window.CurrentSelectedCheckOut.getDate();
            let ThisCheckOutMonth = window.CurrentSelectedCheckOut.getMonth();
            let ThisCheckOutYear = window.CurrentSelectedCheckOut.getFullYear();

            CheckOutDateText.style.color = "#2494D9";
            CheckOutDateText.innerHTML = ThisCheckOutDay + " " + window["monthNames" + window.CurrentCountryID][ThisCheckOutMonth] + " " + ThisCheckOutYear;
        }
        else
        {
            CheckOutDateText.style.color = "#D92D20";
            CheckOutDateText.innerHTML = window["SelectCheckOutTxt" + window.CurrentCountryID];

            IsInputtedFalse = true;
        }
    }
    else
    {
        if(window.CurrentSelectedDayEdit != null && window.CurrentSelectedMonthEdit != null && window.CurrentSelectedYearEdit != null)
        {
            CheckInDateText.style.color = "#2494D9";
            CheckInDateText.innerHTML = window.CurrentSelectedDayEdit + " " + window["monthNames" + window.CurrentCountryID][(window.CurrentSelectedMonthEdit-1)] + " " + window.CurrentSelectedYearEdit;
        }
        else
        {
            CheckInDateText.style.color = "#D92D20";
            CheckInDateText.innerHTML = window["SelectDateOfVisitTxt" + window.CurrentCountryID];

            IsInputtedFalse = true;
        }
    }


    let ListOfCalendarButton = tablecontainer.querySelectorAll('.DateButton');

    for(let i = 0; i < ListOfCalendarButton.length; i++)
    {
        ListOfCalendarButton[i].className = ListOfCalendarButton[i].getAttribute("original-class");

        let WhichDateThisButtonArray = ListOfCalendarButton[i].getAttribute("What-date").split("-");
        let WhichDateThisButton = new Date(WhichDateThisButtonArray[0], parseInt(WhichDateThisButtonArray[1] - 1), WhichDateThisButtonArray[2]);
        
        if(isallowmorethanone == true && window.CurrentSelectedCheckIn != '')
        {
            if(WhichDateThisButton.getTime() == window.CurrentSelectedCheckIn.getTime())
            {
                if(window.CurrentSelectedCheckOut == '')
                {
                    ListOfCalendarButton[i].classList.add("CalendarCurrentOnlyThisDate");
                }
                else
                {
                    ListOfCalendarButton[i].classList.add("CalendarCurrentStartDate");
                }
            }
            else if(window.CurrentSelectedCheckOut != '')
            {
                if(WhichDateThisButton.getTime() > window.CurrentSelectedCheckIn.getTime() && WhichDateThisButton.getTime() < window.CurrentSelectedCheckOut.getTime())
                {
                    ListOfCalendarButton[i].classList.add("CalendarCurrentMidDate");
                }
                else if(WhichDateThisButton.getTime() == window.CurrentSelectedCheckOut.getTime())
                {
                    ListOfCalendarButton[i].classList.add("CalendarCurrentEndDate");
                }
            }
        }
        else if(isallowmorethanone == false && (window.CurrentSelectedDayEdit != null && window.CurrentSelectedMonthEdit != null && window.CurrentSelectedYearEdit != null))
        {
            let CurrentSelectedDay = new Date(window.CurrentSelectedYearEdit, window.CurrentSelectedMonthEdit-1, window.CurrentSelectedDayEdit);

            console.log(CurrentSelectedDay + " = " + WhichDateThisButton);

            if(CurrentSelectedDay.getTime() == WhichDateThisButton.getTime())
            {
                ListOfCalendarButton[i].classList.add("CalendarCurrentOnlyThisDate");
            }
        }
    }

    window.CheckAndApplyDateButtonAvailability(ListOfCalendarButton, isallowmorethanone, false, SaveButton);


    if(IsInputtedFalse == true)
    {
        HowManyNightsText.innerHTML = "-- " + window["NightTxt" + window.CurrentCountryID];
        SaveButton.className = "BasicTextButton OrangeButton BasicPaddingButton ButtonInvalid";
        SaveButton.onclick = function(){};
    }
    else
    {
        let DifferenceBetweenDays = window.GetDateDifferences(window.CurrentSelectedCheckIn, window.CurrentSelectedCheckOut)
        HowManyNightsText.innerHTML = window.NightTextDisplayer(DifferenceBetweenDays)


        SaveButton.className = "BasicTextButton OrangeButton BasicPaddingButton Selectable";
        SaveButton.onclick = function() 
        {
            console.log("Save Check In Out Mobile");
            ClosePanelFunction();
        }
    }
}



// ======================================== ON CALENDAR BUTTON PRESSED ========================================


window.ThisCalendarDateButtonSelected = function(DateButton, isallinonechoice, functiontocall)
{
    let Day;
    let Month;
    let Year;

    if(DateButton.getAttribute("What-date") != null && DateButton.getAttribute("What-date") != "")
    {
        let DateButtonArray = DateButton.getAttribute("What-date").split("-");

        Day = parseInt(DateButtonArray[2]);
        Month = parseInt(DateButtonArray[1]);
        Year = parseInt(DateButtonArray[0]);
    }
    else
    {
        Day = parseInt(DateButton.getAttribute("date"));
        Month = parseInt(DateButton.getAttribute("month"));
        Year = parseInt(DateButton.getAttribute("year"));
    }


    if(!isallinonechoice)
    {
        window.CurrentSelectedDayEdit = Day;
        window.CurrentSelectedMonthEdit = Month;
        window.CurrentSelectedYearEdit = Year;

        console.log("window.CurrentSelectedDayEdit", window.CurrentSelectedDayEdit);
        console.log("window.CurrentSelectedMonthEdit", window.CurrentSelectedMonthEdit);
        console.log("window.CurrentSelectedYearEdit", window.CurrentSelectedYearEdit);
    }
    else
    {
        let SelectedDate = new Date(Year, Month - 1, Day);

        // Nothing selected yet --------------------------------------------------------------------------
        if(window.CurrentSelectedCheckIn == '')
        {
            window.CurrentSelectedCheckIn = SelectedDate;
        }

        // Range already complete → start a new range ----------------------------------------------------
        else if(window.CurrentSelectedCheckOut != '')
        {
            window.CurrentSelectedCheckIn = SelectedDate;
            window.CurrentSelectedCheckOut = '';
        }

        // Selecting checkout ----------------------------------------------------------------------------
        else
        {
            if(SelectedDate > window.CurrentSelectedCheckIn)
            {
                window.CurrentSelectedCheckOut = SelectedDate;
            }
            else if(SelectedDate < window.CurrentSelectedCheckIn)
            {
                window.CurrentSelectedCheckIn = SelectedDate;
            }
            else
            {
                // Same date -----------------------------------------------------------------------------
                if(window.IsAllowSameDate)
                {
                    window.CurrentSelectedCheckOut = SelectedDate;
                }
                else
                {
                    window.CurrentSelectedCheckIn = '';
                }
            }
        }
    }

    if(functiontocall != null)
        functiontocall();
}

// ================================================ CHECK IF ROOM EXIST ================================================

window.CurrentCheckedExistData = {};
window.CurrentLoadingMonthAvailability = {};

window.GetMonthKey = function(month, year)
{
    return `${year}-${String(month).padStart(2, "0")}`;
}

window.CheckWhichDateExist = function(month, year, DateButtonsList, ThisLoading, isallinonechoice, ApplyMonthButton, functiontocall)
{
    window.EnsureMonthLoaded(month, year)
    .then(async () =>
    {
        await window.EnsureVisibleMonthsLoaded(month, year);

        ThisLoading.remove();

        if(functiontocall)
            functiontocall();

        window.CheckAndApplyDateButtonAvailability(DateButtonsList, isallinonechoice, true, ApplyMonthButton);

        window.PrefetchNearbyMonths(month, year);
    })
    .catch(err =>
    {
        console.log(err);

        DateButtonsList.forEach(btn =>
        {
            btn.style.opacity = "";
            btn.style.pointerEvents = "";
        });

        ThisLoading.remove();
    });
}


window.EnsureVisibleMonthsLoaded = async function(month, year)
{
    const Current = new Date(year, month - 1, 1);

    const Previous = new Date(Current);
    Previous.setMonth(Current.getMonth() - 1);

    const Next = new Date(Current);
    Next.setMonth(Current.getMonth() + 1);

    await Promise.all([
        window.EnsureMonthLoaded(
            Previous.getMonth() + 1,
            Previous.getFullYear()
        ),
        window.EnsureMonthLoaded(
            Current.getMonth() + 1,
            Current.getFullYear()
        ),
        window.EnsureMonthLoaded(
            Next.getMonth() + 1,
            Next.getFullYear()
        )
    ]);
}


window.EnsureMonthLoaded = function(month, year)
{
    const Key = window.GetMonthKey(month, year);

    // Already loaded
    if(window.CurrentCheckedExistData[Key])
    {   
        return Promise.resolve();
    }

    // Already loading
    if(window.CurrentLoadingMonthAvailability[Key])
    {
        return window.CurrentLoadingMonthAvailability[Key];
    }

    let Url = "/v2/rooms/" + window.CurrentSelectedRoomID + "/monthly?month=" + month + "&year=" + year + "&rooms=" + window.RoomQuotaNonTop;
    if(window.CurrentSelectedAccFacilitiesType === "Experiences")
    {
        Url = "/v2/hotel-experiences/" + window.CurrentSelectedRoomID + "/monthly?year_month=" + year + "-" + month.toString().padStart(2, '0');
    }

    console.log("EnsureMonthLoaded URL", Url);

    const PromiseRequest = window.CallApiAxios(
    {
        method: "GET",
        url: Url
    })
    .then(res =>
    {
        let Dates = res.data.data.dates;
        console.log("EnsureMonthLoaded Response", Dates);

        const grouped = {};

        Dates.forEach(item =>
        {
            if(!grouped[item.date] || item.status_available == "No")
            {
                grouped[item.date] = item;
            }
        });

        window.CurrentCheckedExistData[Key] = grouped;

        delete window.CurrentLoadingMonthAvailability[Key];
    })
    .catch(err =>
    {
        delete window.CurrentLoadingMonthAvailability[Key];

        throw err;
    });

    window.CurrentLoadingMonthAvailability[Key] = PromiseRequest;

    return PromiseRequest;
}

window.JustLoadRoomExperienceMonthly = async function(startdate, enddate, roomexpid, roomorexptype, functiontocall)
{
    let AllDates = [];

    // Start from the start date
    let CurrentDate = new Date(startdate.getFullYear(), startdate.getMonth(), 1);

    // End date is optional
    let EndDate = null;

    if(enddate != null)
    {
        EndDate = new Date(enddate.getFullYear(), enddate.getMonth(), 1);
    }

    while(true)
    {
        let year = CurrentDate.getFullYear();
        let month = CurrentDate.getMonth() + 1;

        let Url = "/v2/rooms/" + roomexpid + "/monthly?month=" + month + "&year=" + year + "&rooms=" + window.RoomQuotaNonTop;

        if(roomorexptype === "Experiences")
        {
            Url = "/v2/hotel-experiences/" + roomexpid + "/monthly?year_month=" + year + "-" + month.toString().padStart(2, "0");
        }

        console.log("Loading Monthly URL:", Url);

        try
        {
            let res = await window.CallApiAxios(
            {
                method: "GET",
                url: Url
            });

            let Dates = res.data?.data?.dates ?? [];

            console.log("Monthly Response:", year, month, Dates);

            // Append this month's dates
            AllDates.push(...Dates);
        }
        catch(err)
        {
            console.error("Failed loading month:", year, month, err);

            // Decide whether you want to stop or continue.
            // For now, stop if one month fails.
            break;
        }

        // If there is no end date,
        // only load the starting month.
        if(EndDate == null)
        {
            break;
        }

        // We have reached the end month
        if(CurrentDate.getFullYear() === EndDate.getFullYear() && CurrentDate.getMonth() === EndDate.getMonth())
        {
            break;
        }

        // Move to next month
        CurrentDate.setMonth(CurrentDate.getMonth() + 1);
    }

    console.log("ALL MONTHLY DATES:", AllDates);

    if(functiontocall != null)
        functiontocall(AllDates);

    return AllDates;
}


window.PrefetchNearbyMonths = function(month, year)
{
    let Current = new Date(year, month - 1, 1);

    let Previous = new Date(Current);
    Previous.setMonth(Current.getMonth() - 1);

    let Next = new Date(Current);
    Next.setMonth(Current.getMonth() + 1);

    window.EnsureMonthLoaded(
        Previous.getMonth() + 1,
        Previous.getFullYear()
    );

    window.EnsureMonthLoaded(
        Next.getMonth() + 1,
        Next.getFullYear()
    );
}


window.CheckAndApplyDateButtonAvailability = function(DateButtonsList, isallinonechoice, isearlychecking, ApplyMonthButton)
{
    const DateNow = window.GetAndConvertCurrentDate(false);

    let IsCurrentDateInvalid = false;
    let CurrentSelectedFullDate = null;
    
    if(isallinonechoice == false)
        CurrentSelectedFullDate = new Date(window.CurrentSelectedYearEdit, (window.CurrentSelectedMonthEdit - 1), window.CurrentSelectedDayEdit);

    let WhichOneError = [];

    if(window.CurrentSelectedCheckIn == "")
        window.LimitCheckOut = "";
    
    DateButtonsList.forEach(DateButton =>
    {
        let [thisdateDay, thisdateMonth, thisdateYear] = window.GetThisDateButtonDate(DateButton)

        let MonthKey = window.GetMonthKey(thisdateMonth, thisdateYear);

        let MonthData = window.CurrentCheckedExistData[MonthKey];

        if(!MonthData)
            return;

        let DateKey = `${thisdateYear}-${String(thisdateMonth).padStart(2,"0")}-${String(thisdateDay).padStart(2,"0")}`;

        let ThisDateData = MonthData[DateKey];

        let ThisCheckFullDate = new Date(thisdateYear, thisdateMonth - 1, thisdateDay);

        if(!ThisDateData)
            return;

        DateButton.style.opacity = "";
        DateButton.style.pointerEvents = "";

        if(window.ThisRoomData != null)
        {
            const diffInMs = Math.abs(DateNow - ThisCheckFullDate);
            const diffInDays = diffInMs / (1000 * 60 * 60 * 24);

            let MinBookingDate = window.ThisRoomData.min_booking_notice_days;

            if (diffInDays < MinBookingDate)
            {
                let ThisDateClass = DateButton.className; 
                if(DateButton.classList.contains("ThisDateIsUnavailable") == false)
                    ThisDateClass = ThisDateClass + " ThisDateIsUnavailable";

                DateButton.className = ThisDateClass;

                WhichOneError.push(window.ThisRoomData);
            }

            // Which Date Start Max ---------------------------------------------
            let MaxStartDate = window.GetAndConvertCurrentDate(false);
            MaxStartDate.setDate(MaxStartDate.getDate() + MinBookingDate);   

            if(isearlychecking == true)
            {
                if(isallinonechoice == true && ((window.CurrentSelectedCheckIn != "" && window.CurrentSelectedCheckIn.getTime() < MaxStartDate.getTime()) || (window.CurrentSelectedCheckOut != "" && window.CurrentSelectedCheckOut.getTime() < MaxStartDate.getTime())))
                {
                    IsCurrentDateInvalid = true;
                }
                else if(isallinonechoice == false && CurrentSelectedFullDate != null && (CurrentSelectedFullDate.getTime() < MaxStartDate.getTime()))
                {
                    IsCurrentDateInvalid = true;
                }

                WhichOneError.push(window.ThisRoomData);
            }
        }


        if(ThisDateData.status_available == "No")
        {
            let ThisDateClass = DateButton.className;

            if(DateButton.classList.contains("ThisDateIsUnavailable") == false)
                ThisDateClass = ThisDateClass + " ThisDateIsUnavailable";

            DateButton.className = ThisDateClass;

            if(isearlychecking == true)
            {
                if(isallinonechoice == true && ((window.CurrentSelectedCheckIn != "" && window.CurrentSelectedCheckIn.getTime() == ThisCheckFullDate.getTime()) || (window.CurrentSelectedCheckOut != "" && window.CurrentSelectedCheckOut.getTime() == ThisCheckFullDate.getTime())))
                {
                    IsCurrentDateInvalid = true;
                }
                else if(isallinonechoice == false && CurrentSelectedFullDate != null && (CurrentSelectedFullDate.getTime() == ThisCheckFullDate.getTime()))
                {
                    IsCurrentDateInvalid = true;
                }

                WhichOneError.push(window.ThisRoomData);
            }

            if(isallinonechoice == true && window.CurrentSelectedCheckIn != "")
            {
                let ThisLimitCheckOutDateArray = ThisDateData.date.split("-");
                let ThisErrorDate = new Date(ThisLimitCheckOutDateArray[0], parseInt(ThisLimitCheckOutDateArray[1]) - 1, parseInt(ThisLimitCheckOutDateArray[2]));
                if(window.LimitCheckOut == "" && ThisErrorDate.getTime() > window.CurrentSelectedCheckIn.getTime())
                {
                    window.LimitCheckOut = ThisErrorDate;
                }
            }
        }

        if(window.LimitCheckOut != "" && isallinonechoice == true && window.CurrentSelectedCheckIn != "")
        {
            if(window.LimitCheckOut.getTime() < ThisCheckFullDate.getTime())
            {
                let ThisDateClass = DateButton.className;
                if(DateButton.classList.contains("DateButtonInvalid") == false)
                    ThisDateClass = ThisDateClass + " DateButtonInvalid";

                DateButton.className = ThisDateClass;
            }
            else if(window.LimitCheckOut.getTime() == ThisCheckFullDate.getTime())
            {
                DateButton.classList.remove("ThisDateIsUnavailable");
            }
        }

    });

    // If The Date Before The Selected Check In Date Then Blank It -------------------------------
    
    for(let i = 0; i < DateButtonsList.length; i++)
    {
        const Button = DateButtonsList[i];

        let [thisdateDay, thisdateMonth, thisdateYear] = window.GetThisDateButtonDate(Button)
        let ThisCheckFullDate = new Date(thisdateYear, thisdateMonth - 1, thisdateDay);

        if(window.CurrentSelectedCheckIn != "" && isallinonechoice == true && window.CurrentSelectedCheckIn.getTime() > ThisCheckFullDate.getTime())
        {
            let ThisDateClass = Button.className;
            if(Button.classList.contains("DateButtonInvalid") == false)
                ThisDateClass = ThisDateClass + " DateButtonInvalid";

            Button.className = ThisDateClass;
        }
    }

    // Apply The Border Radius for ThisDateIsUnavailable ------------------------------------
    
    for(let i = 0; i < DateButtonsList.length; i++)
    {
        const Button = DateButtonsList[i];

        if(!Button.classList.contains("ThisDateIsUnavailable"))
            continue;

        const Previous = DateButtonsList[i - 1]?.classList.contains("ThisDateIsUnavailable");

        const Next = DateButtonsList[i + 1]?.classList.contains("ThisDateIsUnavailable");

        Button.classList.remove("TheStartDatePanel", "TheMidDatePanel", "TheEndDatePanel", "TheOnlyDatePanel");

        if(!Previous && !Next)
        {
            Button.classList.add("TheOnlyDatePanel");
        }
        else if(!Previous)
        {
            Button.classList.add("TheStartDatePanel");
        }
        else if(!Next)
        {
            Button.classList.add("TheEndDatePanel");
        }
        else
        {
            Button.classList.add("TheMidDatePanel");
        }
    }

    if(IsCurrentDateInvalid == true)
    {
        window.CurrentSelectedDayEdit = null;
        window.CurrentSelectedMonthEdit = null;
        window.CurrentSelectedYearEdit = null;

        window.CurrentSelectedCheckIn = '';
        window.CurrentSelectedCheckOut = '';
    }


    if((isallinonechoice == false && (window.CurrentSelectedDayEdit == null || window.CurrentSelectedMonthEdit == null || window.CurrentSelectedYearEdit == null)) || (isallinonechoice == true && (window.CurrentSelectedCheckIn == "" || window.CurrentSelectedCheckOut == "")))
    {
        if(ApplyMonthButton.classList.contains("OrangeButton") == true)
        {
            ApplyMonthButton.className = "BasicTextButton OrangeButton BasicPaddingButton ButtonInvalid";
        }
        else
        {
            ApplyMonthButton.className = "ApplyMonthButton BasicRadius ButtonInvalid";
        }
    }
    else
    {
        if(ApplyMonthButton.classList.contains("OrangeButton") == true)
        {
            ApplyMonthButton.className = "BasicTextButton OrangeButton BasicPaddingButton Selectable";
        }
        else
        {
            ApplyMonthButton.className = "ApplyMonthButton BasicRadius Selectable";
        }

    }
}

window.GetThisDateButtonDate = function(DateButton)
{
    let thisdateDay;
    let thisdateMonth;
    let thisdateYear;

    if(DateButton.getAttribute("What-date") != null && DateButton.getAttribute("What-date") != "")
    {
        let ThisDateButtonArray = DateButton.getAttribute("What-date").split("-");
            
        thisdateDay = parseInt(ThisDateButtonArray[2]);
        thisdateMonth = parseInt(ThisDateButtonArray[1]);
        thisdateYear = parseInt(ThisDateButtonArray[0]);
    }
    else
    {
        thisdateDay = parseInt(DateButton.getAttribute("date"));
        thisdateMonth = parseInt(DateButton.getAttribute("month"));
        thisdateYear = parseInt(DateButton.getAttribute("year"));
    }

    return [thisdateDay, thisdateMonth, thisdateYear]
}

window.CanCheckoutDate = function(CheckIn, CheckOut)
{
    let Current = new Date(CheckIn);

    Current.setDate(Current.getDate() + 1);

    while(Current < CheckOut)
    {
        let MonthKey = window.GetMonthKey(
            Current.getMonth() + 1,
            Current.getFullYear()
        );

        let DateKey =
            `${Current.getFullYear()}-${String(Current.getMonth()+1).padStart(2,"0")}-${String(Current.getDate()).padStart(2,"0")}`;

        let Data =
            window.CurrentCheckedExistData[MonthKey]?.[DateKey];

        if(Data && Data.status_available == "No")
        {
            return false;
        }

        Current.setDate(Current.getDate() + 1);
    }

    return true;
}

window.ApplyDateChanges = function(ThisDropDownContainer, whichdatecontainerid, opposingcontainerid, functiontocall, isallinonechoice)
{
    window.event.preventDefault();
    window.event.stopPropagation();

    ThisDropDownContainer.remove();

    // ============================================================
    // APPLY DATE
    // ============================================================

    if(isallinonechoice)
    {
        let CheckInDate;
        let CheckOutDate;

        if(window.ThisStartEndType == "Start")
        {
            CheckInDate = window.CurrentSelectedCheckIn;
            CheckOutDate = window.CurrentSelectedCheckOut;
        }
        else
        {
            CheckInDate = window.CurrentSelectedCheckOut;
            CheckOutDate = window.CurrentSelectedCheckIn;
        }

        let WhichDate = window.ThisStartEndType == "Start" ? CheckInDate : CheckOutDate;

        let OpposingDate = window.ThisStartEndType == "Start" ? CheckOutDate : CheckInDate;

        SetContainerDate(window.WhichDateContainer, WhichDate);
        SetContainerDate(window.OpposingContainer, OpposingDate);

        DisplayDate(whichdatecontainerid, WhichDate);
        DisplayDate(opposingcontainerid, OpposingDate);
    }
    else
    {
        let SelectedDate = new Date(window.CurrentSelectedYearEdit, window.CurrentSelectedMonthEdit - 1, window.CurrentSelectedDayEdit);

        SetContainerDate(window.WhichDateContainer, SelectedDate);
        DisplayDate(whichdatecontainerid, SelectedDate);

        // If Check-In >= Check-Out, move Check-Out to next day

        if(window.ThisStartEndType == "Start" && window.OpposingContainer != "")
        {
            let OpposingDate = GetContainerDate(window.OpposingContainer);

            let IsSameDate = SelectedDate.getTime() == OpposingDate.getTime();

            let IsAfter = SelectedDate.getTime() > OpposingDate.getTime();

            if((!window.IsAllowSameDate && IsSameDate) || IsAfter)
            {
                OpposingDate = new Date(SelectedDate.getFullYear(), SelectedDate.getMonth(), SelectedDate.getDate() + 1);

                SetContainerDate(window.OpposingContainer, OpposingDate);
                DisplayDate(opposingcontainerid, OpposingDate);
            }
        }
    }

    // ============================================================
    // CALCULATE NIGHT
    // ============================================================

    if(window.WhichHowManyTextDisplayer != null && window.OpposingContainer != "")
    {
        let StartContainer = window.ThisStartEndType == "Start" ? window.WhichDateContainer : window.OpposingContainer;

        let EndContainer = window.ThisStartEndType == "End" ? window.WhichDateContainer : window.OpposingContainer;

        let StartDate = GetContainerDate(StartContainer);
        let EndDate = GetContainerDate(EndContainer);

        let DifferenceBetweenDays = window.GetDateDifferences(EndDate, StartDate);

        window.WhichHowManyTextDisplayer.innerHTML = window.NightTextDisplayer(DifferenceBetweenDays);
    }

    // ============================================================
    // CALLBACK
    // ============================================================

    if(functiontocall != null)
    {
        if(typeof functiontocall === "string")
            eval(functiontocall);
        else
            functiontocall();
    }
}

function SetContainerDate(container, date)
{
    container.setAttribute("date", date.getDate());
    container.setAttribute("month", date.getMonth() + 1);
    container.setAttribute("year", date.getFullYear());
}

function GetContainerDate(container)
{
    return new Date(
        parseInt(container.getAttribute("year")),
        parseInt(container.getAttribute("month")) - 1,
        parseInt(container.getAttribute("date"))
    );
}

function FormatDateToDisplay(date)
{
    let Day = date.getDate();
    let Month = date.getMonth();
    let Year = date.getFullYear();

    let MonthName = window["monthNames" + window.CurrentCountryID][Month];

    if(window.WhatDisplayFormat == 1)
        return Day + " " + MonthName + " " + Year;

    if(window.WhatDisplayFormat == 2)
        return MonthName + " " + Day + ", " + Year;

    return "";
}

function DisplayDate(containerid, date)
{
    let DateText = document.getElementById(containerid + "DateText");
    let DayNameText = document.getElementById(containerid + "DayNameText");

    if(DateText != null)
    {
        let Display = FormatDateToDisplay(date);

        if(DateText.tagName == "INPUT")
            DateText.value = Display;
        else
            DateText.innerHTML = Display;
    }

    if(DayNameText != null)
    {
        DayNameText.innerHTML =
            window["weekdayFull" + window.CurrentCountryID][date.getDay()];
    }
}


window.NextDateOrPastChange = function(valueadd, PreviousMonthButton, CurrentMonthandYear, allowcheckinavailability, durationtransition, isallinonechoice, ApplyMonthButton)
{
    window.event.preventDefault();
    window.event.stopPropagation();

    if(window.IsCalendarAnimating == true)
        return

    // ============================= ADDING THE VALUE ====================================

    if(valueadd > 0  && window.CurrentDisplayedMonthEdit == 12)
    {
        window.CurrentDisplayedMonthEdit = 1;
        window.CurrentDisplayedYearEdit = window.CurrentDisplayedYearEdit + 1;
    }
    else if(valueadd < 0 && window.CurrentDisplayedMonthEdit == 1)
    {
        window.CurrentDisplayedMonthEdit = 12;
        window.CurrentDisplayedYearEdit = window.CurrentDisplayedYearEdit - 1;
    }
    else
    {
        window.CurrentDisplayedMonthEdit = window.CurrentDisplayedMonthEdit + valueadd;
    }

    window.InstantiateDatesInsideContainer(CurrentMonthandYear, durationtransition, allowcheckinavailability, isallinonechoice, ApplyMonthButton);
    
    // ============================ HIDE AND DISPLAY NEXT PREV BUTTON ===============================

    let CurrentDisplayedDate = new Date(window.CurrentDisplayedYearEdit, window.CurrentDisplayedMonthEdit-1, 1);

    let WhatDayIsToday = window.GetAndConvertCurrentDate(false);
    let TodayConvertedDate = new Date(WhatDayIsToday.getFullYear(), WhatDayIsToday.getMonth(), 1);

    PreviousMonthButton.style.display = "";

    if(window.DontAllowPastDate == true && CurrentDisplayedDate.getTime() <= TodayConvertedDate.getTime())
    {
        PreviousMonthButton.style.display = "none";
    }
    else if(window.ThisStartEndType == "End")
    {
        let OpposingDate = parseInt(window.OpposingContainer.getAttribute("date"));
        let OpposingMonth = parseInt(window.OpposingContainer.getAttribute("month"));
        let OpposingYear = parseInt(window.OpposingContainer.getAttribute("year"));
    
        let OpposingFullDateCheck1 = new Date(OpposingYear, OpposingMonth-1, 1);
        let OpposingFullDateCheckIfThisLast = new Date(OpposingYear, OpposingMonth-1, OpposingDate);

        let diffDays = window.GetDateDifferences(OpposingFullDateCheckIfThisLast, CurrentDisplayedDate)
        // let diffTime = Math.abs(OpposingFullDateCheckIfThisLast - CurrentDisplayedDate);
        // let diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24)); 

        if(CurrentDisplayedDate.getTime() <= OpposingFullDateCheck1.getTime() || (window.IsAllowSameDate == false && diffDays == 1))
        {
            PreviousMonthButton.style.display = "none";
        }
    }
}

window.OpenMonthChoiceDropDown = function(allowcheckinavailability, isallinonechoice, ApplyMonthButton)
{
    let BasicBlackBlocker = document.createElement("div");
    BasicBlackBlocker.className = "BasicBlackBlocker";
    BasicBlackBlocker.onclick = function()
    {
        window.event.preventDefault();
        window.event.stopPropagation();
        window.RotateToggle("", true);

        if(window.DropDownInsideContainer != null)
        {
            window.DropDownInsideContainer.remove();
            window.DropDownInsideContainer = null;
        }
        else
        {
            BasicBlackBlocker.remove();
            //document.getElementsByTagName("body")[0].style.overflow = "auto";
        }
    }
    document.getElementsByTagName("body")[0].append(BasicBlackBlocker);

    let ChoicePanelContainer = document.createElement("div");
    ChoicePanelContainer.className = "FlexFullDisplayPanel";
    ChoicePanelContainer.style.overflow = "visible";
    ChoicePanelContainer.onclick = function()
    {
        window.event.preventDefault();
        window.event.stopPropagation();
        window.RotateToggle("", true);
        if(window.DropDownInsideContainer != null)
        {
            window.DropDownInsideContainer.remove();
            window.DropDownInsideContainer = null;
        }
    }
    BasicBlackBlocker.append(ChoicePanelContainer);

    let MonthHeaderText = document.createElement("p");
    MonthHeaderText.className = "SmallPanelHeaderText InterBoldTextFont";
    MonthHeaderText.innerHTML = window["MonthTxt" + window.CurrentCountryID] + ":";
    ChoicePanelContainer.append(MonthHeaderText);

    let MonthDropDownContainer = document.createElement("div");
    MonthDropDownContainer.className = "SmallPanelDropDownContainer";
    MonthDropDownContainer.setAttribute("current-month", window.CurrentDisplayedMonthEdit);
    ChoicePanelContainer.append(MonthDropDownContainer);

    let MonthDropDownInputWrapper = document.createElement("div");
    MonthDropDownInputWrapper.className = "SmallPanelDropDownInputWrapper Selectable3 InterMediumTextFont";
    MonthDropDownContainer.append(MonthDropDownInputWrapper);

    let MonthDropDownInputText = document.createElement("p");
    MonthDropDownInputText.className = "MonthInputChangeCurrentSelectedText";
    MonthDropDownInputText.innerHTML = window["monthNamesFull" + window.CurrentCountryID][window.CurrentDisplayedMonthEdit-1];
    MonthDropDownInputWrapper.append(MonthDropDownInputText);

    let MonthDropDownChevron = document.createElement("img");
    MonthDropDownChevron.className = "ChevronInsideInput ToggleArrow";
    MonthDropDownChevron.id = "MonthDropDownChevron";
    MonthDropDownChevron.style.rotate = "0deg";
    MonthDropDownChevron.src = "/Assets/images/ButtonIcon/chevron.svg";
    MonthDropDownInputWrapper.append(MonthDropDownChevron);


    let YearHeaderText = document.createElement("p");
    YearHeaderText.className = "SmallPanelHeaderText InterBoldTextFont";
    YearHeaderText.innerHTML = window["YearTxt" + window.CurrentCountryID] + ":";
    ChoicePanelContainer.append(YearHeaderText);

    let YearDropDownContainer = document.createElement("div");
    YearDropDownContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer Selectable3";
    ChoicePanelContainer.append(YearDropDownContainer);

    let YearInput = document.createElement("input");
    YearInput.type = "number";
    YearInput.placeholder = "eg: 2024";
    YearInput.className = "InputFieldInsideSmallPanel InputFieldSelectable InterMediumTextFont";
    YearInput.value = window.CurrentDisplayedYearEdit;
    YearDropDownContainer.append(YearInput);


    MonthDropDownInputWrapper.onclick = function()
    {
        window.OpenDropDownMonth(MonthDropDownContainer, MonthDropDownInputText, YearInput.value);
    }

    YearInput.onfocus = function()
    {
        window.event.preventDefault();
        window.event.stopPropagation();
    }
    YearInput.addEventListener("focusout", (event) =>
    {
        let WhatDayIsToday = window.GetAndConvertCurrentDate(false);
        let ThisYear = WhatDayIsToday.getFullYear();
        let ThisMonth = WhatDayIsToday.getMonth();

        let CurrentInputMonth = parseInt(MonthDropDownContainer.getAttribute("current-month"));

        if(YearInput.value == null || YearInput.value == "")
        {
            YearInput.value = ThisYear;
        }
        else
        {
            
            if(YearInput.value <= ThisYear)
            {
                YearInput.value = ThisYear;
                if(CurrentInputMonth < (ThisMonth+1))
                {
                    MonthDropDownContainer.setAttribute("current-month", (ThisMonth+1));
                    MonthDropDownInputText.innerHTML = window["monthNamesFull" + window.CurrentCountryID][ThisMonth];
                }
            }
        }
    });


    // Button ----------

    let SmallPanelBottomButtonWrapper = document.createElement("div");
    SmallPanelBottomButtonWrapper.className = "SmallPanelBottomButtonWrapper";
    ChoicePanelContainer.append(SmallPanelBottomButtonWrapper);

    let CancelButton = document.createElement("button");
    CancelButton.className = "TextButtonSmallPanel InterBoldTextFont Selectable";
    CancelButton.onclick = function()
    {
        window.event.preventDefault();
        window.event.stopPropagation();
        window.RotateToggle("", true);

        BasicBlackBlocker.remove();
        // document.getElementsByTagName("body")[0].style.overflow = "auto";
    }
    CancelButton.innerHTML = window["CancelTxt" + window.CurrentCountryID];
    SmallPanelBottomButtonWrapper.append(CancelButton);

    let ApplyButton = document.createElement("button");
    ApplyButton.className = "BasicButtonSmallPanel InterMediumTextFont Selectable";
    ApplyButton.onclick = function()
    {
        window.event.preventDefault();
        window.event.stopPropagation();
        window.RotateToggle("", true);

        window.CurrentDisplayedMonthEdit = parseInt(MonthDropDownContainer.getAttribute("current-month"));
        window.CurrentDisplayedYearEdit = YearInput.value;
        window.NextDateOrPastChange(0, document.getElementById("PreviousMonthButton"), document.getElementById("CurrentMonthandYearToEdit"), allowcheckinavailability, 100, isallinonechoice, ApplyMonthButton);
        
        BasicBlackBlocker.remove();
        //document.getElementsByTagName("body")[0].style.overflow = "auto";
    }
    ApplyButton.innerHTML = window["ApplyTxt" + window.CurrentCountryID];
    SmallPanelBottomButtonWrapper.append(ApplyButton);

    //document.getElementsByTagName("body")[0].style.overflow = "hidden";
}

window.OpenDropDownMonth = function(MonthDropDownContainer, MonthDropDownInputText, YearInputValue)
{
    window.event.preventDefault();
    window.event.stopPropagation();
    window.RotateToggle("MonthDropDownChevron", true);

    if(window.DropDownInsideContainer != null)
    {
        window.DropDownInsideContainer.remove();
        window.DropDownInsideContainer = null;
    }
    else
    {
        let WhatDayIsToday = window.GetAndConvertCurrentDate(false);
        let WhatMonth = WhatDayIsToday.getMonth();
        let WhatYear = WhatDayIsToday.getFullYear();
        console.log(WhatDayIsToday);
    
        window.DropDownInsideContainer = document.createElement("div");
        window.DropDownInsideContainer.className = "ContainerFlex";
        window.DropDownInsideContainer.style.bottom = 0;
        MonthDropDownContainer.append(window.DropDownInsideContainer);
    
        let DropDownContainer = document.createElement("div");
        DropDownContainer.className = "DropDownContainer HideScrollBar";
        window.DropDownInsideContainer.append(DropDownContainer);
    
    
        let CurrentSelected = parseInt(MonthDropDownContainer.getAttribute("current-month"));
        let ScrollToDropDown;
    
        for(let i = 0; i < window["monthNamesFull" + window.CurrentCountryID].length; i++)
        {
            let DropDownSelectionContainer = document.createElement("button");
            DropDownSelectionContainer.className = "DropDownSelectionContainer";
    
            if(i < WhatMonth && YearInputValue == WhatYear)
            {
                DropDownSelectionContainer.classList.add("DropDownInvalid");
                DropDownSelectionContainer.onclick = function()
                {
                    window.event.preventDefault();
                    window.event.stopPropagation();
                }
            }
            else 
            {
                if(CurrentSelected == (i+1))
                {
                    DropDownSelectionContainer.classList.add("DropDownSelectionContainerSelected");
                    ScrollToDropDown = DropDownSelectionContainer;
                }

                DropDownSelectionContainer.onclick = function()
                {
                    MonthDropDownContainer.setAttribute("current-month", i+1);
                    MonthDropDownInputText.innerHTML = window["monthNamesFull" + window.CurrentCountryID][i];
                }
            }
            DropDownContainer.append(DropDownSelectionContainer);
        
            let DropDownSelectionText = document.createElement("p");
            DropDownSelectionText.className = "DropDownSelectionText";
            DropDownSelectionText.innerHTML = window["monthNamesFull" + window.CurrentCountryID][i];
            DropDownSelectionContainer.append(DropDownSelectionText);
        }

        window.ScrollToSelectedDropDown(DropDownContainer, ScrollToDropDown)
    }
}

// ============================================== TIMER RELATED FUNCTIONS =========================================

window.EndTimeCountDown = null;
window.wasHidden = false;
window.CountDownTimerInterval = null;
window.VisibilityChangeHandler = null;

window.StartCountDown = function(whichtext, whichtype, functioncallafterreload, functioncallafterend) // Start Countdown
{
    window.RemoveTimerAndVisibility(true);

    // Add Function On Visibility Change -------------------------------------
    window.AddOnVisibilityChangeFunction(functioncallafterreload);

    // Start Timer -------------------------------------
    window.updateTimer(whichtext, whichtype, functioncallafterend);

    window.CountDownTimerInterval = setInterval(() =>
    {
        window.updateTimer(whichtext, whichtype, functioncallafterend);
    }, 1000);
}


window.updateTimer = function(whichtext, whichtype, functioncallafterend) // Update Countdown
{
    let now = window.ConvertThisToDate(null, true);
    let currenttime = Math.max(0, Math.floor((window.EndTimeCountDown - now) / 1000));

    let Hours = Math.floor(currenttime / 3600);
    let Minute = Math.floor((currenttime - (Hours * 3600)) / 60);
    let Second = currenttime - (Hours * 3600) - (Minute * 60);
    let MessageTextToDisplay = "";

    if(whichtype = 1)
    {
        let HoursMessage =  Hours.toString().padStart(2, '0') +  " " + window["HourTxt" + window.CurrentCountryID].toLowerCase() + " : ";
        if(Hours > 1)
        {
            HoursMessage =  Hours.toString().padStart(2, '0') +  " " + window["HourTxtex" + window.CurrentCountryID].toLowerCase() + " : ";
        }

        let MinutesMessage =  Minute.toString().padStart(2, '0') +  " " + window["MinTxt" + window.CurrentCountryID].toLowerCase() + " : ";
        if(Minute > 1)
        {
            MinutesMessage =  Minute.toString().padStart(2, '0') +  " " + window["MinTxtex" + window.CurrentCountryID].toLowerCase() + " : ";
        }

        let SecondMessage =  Second.toString().padStart(2, '0') +  " " + window["SecTxt" + window.CurrentCountryID].toLowerCase();
        if(Second > 1)
        {
            SecondMessage =  Second.toString().padStart(2, '0') +  " " + window["SecTxtex" + window.CurrentCountryID].toLowerCase();
        }

        MessageTextToDisplay = HoursMessage + MinutesMessage + SecondMessage;
    }
    
    if(Array.isArray(whichtext))
    {
        whichtext.forEach(element =>
        {
            element.innerHTML = MessageTextToDisplay;
        });
    }
    else
    {
        whichtext.innerHTML = MessageTextToDisplay;
    }

    if(currenttime <= 0)
    {
        window.RemoveTimerAndVisibility(false);

        if (typeof functioncallafterend === 'function')
        {
            functioncallafterend();
        }
    }
}

window.RemoveTimerAndVisibility = function(isremoveeventlistener) // Remove Timer + Visibility
{
    if(window.CountDownTimerInterval === null || isremoveeventlistener == false) // Clear Countdown
    {
        clearInterval(window.CountDownTimerInterval);
    }

    if(isremoveeventlistener == true) // Remove Visibility Change Function
    {
        document.removeEventListener("visibilitychange", window.VisibilityChangeHandler);
    }
}

// =========================== OTHER DATE TIME RELATED ===========================

window.ConvertThisToDate = function(thisdatedata, isthisalreadyutc) // Get Today Date or Convert Date and Time String Into DATE Value 
{
    let DateToReturn;

    if(thisdatedata == null)
    {
        const now = new Date();
        const utc = now.getTime() + now.getTimezoneOffset() * 60000;
        const jakartaOffset = 7 * 60 * 60000; // UTC+7
        DateToReturn = new Date(utc + jakartaOffset);
    }
    else
    {
        thisdatedata = (thisdatedata || "").trim();
        
        if (/^\d{4}-\d{2}-\d{2}T/.test(thisdatedata))
        {
            let d = new Date(thisdatedata);
            if (!isNaN(d)) return d;
        }

        let DateArray = [];
        let TimeArray = [];

        if(thisdatedata === "")
        {
            const now = new Date();
            const utc = now.getTime() + now.getTimezoneOffset() * 60000;
            const jakartaOffset = 7 * 60 * 60000;
            return new Date(utc + jakartaOffset);
        }

        if(thisdatedata.includes(" ") && thisdatedata.includes("-") && thisdatedata.includes(":"))
        {
            let TimeDateArray = thisdatedata.split(" ");
            DateArray = TimeDateArray[0].split("-");
            TimeArray = TimeDateArray[1].split(":");
        }
        else
        {
            DateArray = thisdatedata.split("-");
            TimeArray = [0, 0, 0];
        }

        if(isthisalreadyutc == true)
        {
            return new Date(DateArray[0], DateArray[1]-1, DateArray[2], TimeArray[0], TimeArray[1], TimeArray[2]);
        }
        else
        {
            return new Date(Date.UTC(DateArray[0], DateArray[1]-1, DateArray[2], TimeArray[0], TimeArray[1], TimeArray[2]));
        }
    }

    return DateToReturn;
}

window.formatDateTime = function(date) // Convert This Date Value To Sting ---------------------------------------
{
    const pad = (n) => n.toString().padStart(2, '0');

    return date.getFullYear() + '-' +
        pad(date.getMonth() + 1) + '-' +
        pad(date.getDate()) + ' ' +
        pad(date.getHours()) + ':' +
        pad(date.getMinutes()) + ':' +
        pad(date.getSeconds());
}

window.GetAndConvertCurrentDate = function(returninconverted) // This one Exclusively convert Time to 00:00:00 ----------------------
{
    let TodayDate = new Date();
    let ConvertedDate = window.ConvertDateTimeZone(TodayDate);
    const SplittedDateArray = ConvertedDate.split("/");
    let ThisFullTime = window.ConvertHourTimeZone(TodayDate).split(":");
    let ThisHour = parseInt(ThisFullTime[0]);
    if(ThisHour == 24)
    {
        ThisHour = 0;
    }
    let ThisMinutes = parseInt(ThisFullTime[1]);
    let ThisSecond = parseInt(ThisFullTime[2]);

    let NewFullDate = SplittedDateArray[2] + "-" + SplittedDateArray[0].toString().padStart(2, '0') + "-" + SplittedDateArray[1].toString().padStart(2, '0') + " " + ThisHour + ":" + ThisMinutes + ":" + ThisSecond;
    if(returninconverted == false)
    {
        NewFullDate = new Date(SplittedDateArray[2], parseInt(SplittedDateArray[0])-1, SplittedDateArray[1]);
    }
    return NewFullDate;
}

window.GetAndConvertCurrentExactDate = function(returninconverted) // This one Exclusively Don't Convert Time ----------------------
{
    const now = new Date();

    // Convert to Jakarta time
    const jakarta = new Date(
        now.toLocaleString("en-US", { timeZone: "Asia/Jakarta" })
    );

    if (returninconverted)
    {
        return window.formatDateTime(jakarta);
    }

    return jakarta;
}

// function WhichDayArrayJakarta()
// {
//     // Get current date and time in Asia/Jakarta timezone
//     let jakartaDate = new Date().toLocaleString('en-US', { timeZone: 'Asia/Jakarta' });

//     // Convert to Date object
//     let dateInJakarta = new Date(jakartaDate);

//     // Get the day of the week as a number (0 = Sunday, 1 = Monday, ..., 6 = Saturday)
//     let dayOfWeek = dateInJakarta.getUTCDay();

//     // Adjust the day number so that 1 = Monday and 7 = Sunday
//     let dayNumber = (dayOfWeek === 0) ? 6 : dayOfWeek - 1;
//     return dayNumber;
// }

window.ConvertDateTimeZone = function(thishour)
{
    let options = {
        timeZone: 'Asia/Jakarta',
        year: "numeric",
        month: "numeric",
        day: "numeric",
    },
    formatter = new Intl.DateTimeFormat('en-US', options);

    return formatter.format(thishour);
}

window.ConvertHourTimeZone = function(thishour)
{
    let options = {
        timeZone: 'Asia/Jakarta',
        hourCycle: "h24",
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
    },
    formatter = new Intl.DateTimeFormat('en-US', options);

    return formatter.format(thishour);
}



// function ConvertDatesAndTimeFromDatabase(thistime)
// {
//     let DateTimeArray = thistime.split(" ");
//     let FullDate = new Date(DateTimeArray[0]);

//     let FullTimeArray = DateTimeArray[1].split(":");
//     ResultDate = FullDate.setHours(FullTimeArray[0], FullTimeArray[1], FullTimeArray[2]);

//     console.log("Converting Date...");
//     console.log(thistime);
//     console.log(ResultDate);
//     return FullDate;
// }

// function CalculateTimeDifferences(firstdate, seconddate)
// {
//     let t1 = firstdate;
//     let t2 = seconddate;
//     let dif = (t2.getTime() - t1.getTime()) / 1000;
//     return dif;
// }

// function GetHowManyDayIsThisMonth(month, year)
// {
//     return new Date(year, month, 0).getDate();
// }

window.ConvertTimeIntoAMPMValue = function(thistime) // Convert Time String Into Time Array With AM PM
{
    let [hour, minute, second] = thistime.split(":").map(Number);

    let ampm = hour >= 12 ? "PM" : "AM";

    hour = hour % 12;
    hour = hour === 0 ? 12 : hour;

    let ArrayToReturn = 
    {
        "hour":hour,
        "minute":minute,
        "ampm":ampm,
    }

    return ArrayToReturn;
}

window.to24HourFormat = function(hour, minutes, ampm) // Convert Date Into 24 Hour Format
{
    hour = parseInt(hour, 10);
    minutes = parseInt(minutes, 10);

    if(ampm.toUpperCase() === "PM" && hour !== 12)
    {
        hour += 12;
    }
    if(ampm.toUpperCase() === "AM" && hour === 12)
    {
        hour = 0;
    }

    // Pad with leading zeros
    let hourStr = hour.toString().padStart(2, '0');
    let minuteStr = minutes.toString().padStart(2, '0');

    return `${hourStr}:${minuteStr}:00`;
}

window.formatDatetoString = function(date) // Convert Date To String Format YYYY-MM-DD
{
    const year = date.getFullYear();

    const month = String(date.getMonth() + 1).padStart(2, "0");

    const day = String(date.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
}

window.ConvertArrayedDateString = function(date) // Reconvert String Date To Correct Format YYYY-MM-DD
{
    const ThisDateArray = date.split("-");
    const ThisMonth = String(ThisDateArray[1]).padStart(2, "0");
    const ThisDate = String(ThisDateArray[2]).padStart(2, "0");

    return `${ThisDateArray[0]}-${ThisMonth}-${ThisDate}`;
}

window.ConvertDateStringToDateFormat = function(date) // Reconvert String Date To Date
{
    const ThisDateArray = date.split("-");
    const FinalDate = new Date(ThisDateArray[0], parseInt(ThisDateArray[1])-1, ThisDateArray[2]);

    return FinalDate;
}

// =============================== SET DISPLAY CHECK IN AND OUT DATE =======================================

window.DisplayFinalCheckInOutDat = function(checkindate, checkoutdate, isabrev, isdispaydayname)
{
    const cin = new Date(checkindate);
    const cout = new Date(checkoutdate);

    if (isNaN(cin.getTime()) || isNaN(cout.getTime())) {
        return "";
    }

    // Determine language suffix (defaults to 'id' if CurrentCountryID is undefined)
    const lang = window.CurrentCountryID || 'id';
    
    const isAbbr = Boolean(isabrev);
    const showDay = Boolean(isdispaydayname);
    
    // Dynamic lookup using window.CurrentCountryID
    const months = isAbbr 
        ? (window[`monthNames${lang}`] || window.monthNamesid)
        : (window[`monthNamesFull${lang}`] || window.monthNamesFullid);
        
    const weekdays = isAbbr 
        ? (window[`weekday${lang}`] || window.weekdayid)
        : (window[`weekdayFull${lang}`] || window.weekdayFullid);

    // Extract Date Components
    const cinDayNum = cin.getDate();
    const coutDayNum = cout.getDate();
    
    const cinMonth = months[cin.getMonth()];
    const coutMonth = months[cout.getMonth()];
    
    const cinYear = cin.getFullYear();
    const coutYear = cout.getFullYear();
    
    const cinDayName = weekdays[cin.getDay()];
    const coutDayName = weekdays[cout.getDay()];

    const sameMonth = (cin.getMonth() === cout.getMonth()) && (cinYear === coutYear);
    const sameYear = cinYear === coutYear;

    // Case 1: Same month & same year -> Simplify range and suppress day names
    if (sameMonth) {
        return `${cinDayNum} - ${coutDayNum} ${cinMonth} ${cinYear}`;
    }

    // Case 2: Different months, same year
    if (sameYear) {
        const cinStr = showDay ? `${cinDayName}, ${cinDayNum} ${cinMonth}` : `${cinDayNum} ${cinMonth}`;
        const coutStr = showDay ? `${coutDayName}, ${coutDayNum} ${coutMonth} ${coutYear}` : `${coutDayNum} ${coutMonth} ${coutYear}`;
        return `${cinStr} - ${coutStr}`;
    }

    // Case 3: Across different years
    const cinStr = showDay ? `${cinDayName}, ${cinDayNum} ${cinMonth} ${cinYear}` : `${cinDayNum} ${cinMonth} ${cinYear}`;
    const coutStr = showDay ? `${coutDayName}, ${coutDayNum} ${coutMonth} ${coutYear}` : `${coutDayNum} ${coutMonth} ${coutYear}`;
    
    return `${cinStr} - ${coutStr}`;
};


// ============================== FUNCTION GET TWO DATE/ TIME DIFF =====================================

window.GetDateDifferences = function(whichdatestart, whichdatereducer) // -- Nights
{
    let CheckInDateFormat = whichdatestart;
    let CheckOutDateFormat = whichdatereducer;
    
    if(whichdatestart instanceof Date == false && whichdatereducer instanceof Date == false)
    {
        let CheckInArray = whichdatestart.split("-");
        CheckInDateFormat = new Date(CheckInArray[0], parseInt(CheckInArray[1] - 1), CheckInArray[2]);
        let CheckOutArray = whichdatereducer.split("-");
        CheckOutDateFormat = new Date(CheckOutArray[0], parseInt(CheckOutArray[1] - 1), CheckOutArray[2]);
    }
    let diffTime = Math.abs(CheckInDateFormat - CheckOutDateFormat);
    let diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24)); 
    return diffDays
}

window.GetHowManyPastMinHourDaysDate = function(thisdateandtime) // -- Sec, -- Min, -- Hour, etc
{
    //------------------------------- GET THE FULL DATE --------------------------------------
    
    // var PastTime = "2024-01-04 14:08:11";
    // let PastDateTimeArray = thisdateandtime.split(" ");
    
    // let PastDateArray = PastDateTimeArray[0].split("-");
    // let PastYear = PastDateArray[0];
    // let PastMonth = (parseInt(PastDateArray[1])-1);
    // let PastDay = PastDateArray[2];

    // let PastTimeArray = PastDateTimeArray[1].split(":");
    // let PastHour = PastTimeArray[0];
    // let PastMinutes = PastTimeArray[1];
    // let PastSecond = PastTimeArray[2];

    // let PastFullDateTime = new Date(PastYear, PastMonth, PastDay, PastHour, PastMinutes, PastSecond);

    let PastFullDateTime = window.ConvertThisToDate(thisdateandtime, true);

    //---------------------------------------------------------------------------------------

    let seconds = Math.floor((new Date() - PastFullDateTime) / 1000);

    // Years Ago ---------------
    let interval = seconds / 31536000;
    if (interval > 1)
    {
        return window["monthNames" + window.CurrentCountryID][PastFullDateTime.getMonth()] + " " + PastFullDateTime.getDate() + ", " + PastFullDateTime.getFullYear();
    //   return Math.floor(interval) + " Years Ago";
    }

    // Months Ago ---------------
    interval = seconds / 2592000;
    if (interval > 1)
    {
        return window["monthNames" + window.CurrentCountryID][PastFullDateTime.getMonth()] + " " + PastFullDateTime.getDate() + ", " + PastFullDateTime.getFullYear();
    //   return Math.floor(interval) + " Months Ago";
    }

    // Days Ago ---------------
    interval = seconds / 86400;
    if(interval > 1)
    {
        return window.DaysMinsSecsAgoDefiner(Math.floor(interval), "DayAgoTxt")
    }

    // Hours Ago ---------------
    interval = seconds / 3600;
    if(interval > 1)
    {
        return window.DaysMinsSecsAgoDefiner(Math.floor(interval), "HourAgoTxt")
    }

    // Minutes Ago ---------------
    interval = seconds / 60;
    if(interval > 1)
    {
        return window.DaysMinsSecsAgoDefiner(Math.floor(interval), "MinAgoTxt")
    }

    // Seconds Ago ---------------
    return window.DaysMinsSecsAgoDefiner(Math.floor(seconds), "SecAgoTxt")
}

window.getCalendarMonthDiff = function(startDate, endDate)
{
  return ((endDate.getFullYear() - startDate.getFullYear()) * 12 + (endDate.getMonth() - startDate.getMonth()));
}


// =============================== SCROLL TIME MENU ===============================

window.InstantiateTimeScrollDownMenu = function(whichtimecontainerid, whichtimetextid, togglearrowid, instiateatleft, functiontocall)
{
    window.event.preventDefault();
    window.event.stopPropagation();

    window.RotateToggle(togglearrowid, true);

    let WhichVerifyTimeContainer = document.getElementById(whichtimecontainerid);
    let WhichVerifyText = document.getElementById(whichtimetextid);


    let ThisDropDownContainer = window.FunctionCheckInstantiateDropDown("TimeScrollDownContainer" + whichtimecontainerid, WhichVerifyTimeContainer);

    if(ThisDropDownContainer == null)
        return

    ThisDropDownContainer.style.bottom = 0;
    ThisDropDownContainer.className = "ContainerFlex";
    ThisDropDownContainer.innerHTML = "";

    // Load Early Data ------------------------------------------------------------------------------

    let CurrentHour = WhichVerifyTimeContainer.getAttribute("hour-value");
    let CurrentMinutes = WhichVerifyTimeContainer.getAttribute("min-value");
    let CurrentAMPM = WhichVerifyTimeContainer.getAttribute("ampm-value");

    // Instantiate Choice ------------------------------------------------------------------------

    let whitePanelContainer = document.createElement("div");
    whitePanelContainer.className = "WhitePanelContentContainer BasicRadius";
    whitePanelContainer.id = "TimeScrollDownContainer" + whichtimecontainerid;
    whitePanelContainer.onclick = function(event)
    {
        event.preventDefault();
        event.stopPropagation();
    }
    whitePanelContainer.style.top = 0;
    if(instiateatleft == true)
    {
        whitePanelContainer.style.left = 0;
    }
    else
    {
        whitePanelContainer.style.right = 0;
    }
    ThisDropDownContainer.append(whitePanelContainer);

    // ============================== Header Section ==============================

    let TimePickerHeader = document.createElement("div");
    TimePickerHeader.className = "DatePickerHeader";
    whitePanelContainer.append(TimePickerHeader);

    let CurrentTimeText = document.createElement("p");
    CurrentTimeText.className = "CurrentMonthandYear InterBoldTextFont";
    CurrentTimeText.textContent = "2:47 PM";
    TimePickerHeader.append(CurrentTimeText);

    let CurrentTimeCancelContainer = document.createElement("div");
    CurrentTimeCancelContainer.className = "MonthButtonContainer";
    TimePickerHeader.append(CurrentTimeCancelContainer);

    let closeButton = document.createElement("img");
    closeButton.className = "CloseButtonInsidePanel Selectable2";
    closeButton.src = "/Assets/images/ButtonIcon/cancel-x-grey.svg";
    CurrentTimeCancelContainer.append(closeButton);

    // ===== Date Picker Table =====

    let TimeScrollContainerMain = document.createElement("div");
    TimeScrollContainerMain.className = "DatePickerDateTable";
    whitePanelContainer.append(TimeScrollContainerMain);

    let TimeScrollWrapper = document.createElement("div");
    TimeScrollWrapper.className = "PaymentTransferTimeSelectionContainer";
    TimeScrollContainerMain.append(TimeScrollWrapper);


    // === Hour Column ===

    let HourSectionMainContainer = document.createElement("div");
    HourSectionMainContainer.style.cssText = "width: fit-content; height: fit-content; position: relative; display: flex; flex-direction: column;";
    TimeScrollWrapper.append(HourSectionMainContainer);

    let HourSectionHeaderContainer = document.createElement("div");
    HourSectionHeaderContainer.className = "PaymentTransferTypeHeaderContainer";
    HourSectionMainContainer.append(HourSectionHeaderContainer);

    let HourSectionHeaderText = document.createElement("p");
    HourSectionHeaderText.className = "PaymentTransferTypeHeaderText InterBoldTextFont";
    HourSectionHeaderText.textContent = "Hour";
    HourSectionHeaderContainer.append(HourSectionHeaderText);

    let HourSectionScrollContainer = document.createElement("div");
    HourSectionScrollContainer.style.cssText = "width: fit-content; height: fit-content; position: relative;";
    HourSectionMainContainer.append(HourSectionScrollContainer);

    let HourSectionScrollWrapper = document.createElement("div");
    HourSectionScrollWrapper.className = "PaymentTransferTimeHourMinutesScrolParent";
    HourSectionScrollContainer.append(HourSectionScrollWrapper);

    let HourSectionScrollSwiperContainer = document.createElement("div");
    HourSectionScrollSwiperContainer.className = "PaymentTransferTimeHourMinutesScrolWrapper";
    HourSectionScrollWrapper.append(HourSectionScrollSwiperContainer);

    let HourSectionScrollSwiperWrapper = document.createElement("div");
    HourSectionScrollSwiperWrapper.className = "swiper-wrapper";
    HourSectionScrollSwiperContainer.append(HourSectionScrollSwiperWrapper);

    for(let i = 1; i < 13; i++)
    {
        let HourSwiperSlide = document.createElement("div");
        HourSwiperSlide.className = "swiper-slide PaymentTimeScrollable";
        HourSwiperSlide.setAttribute("hour-value", i);
        HourSectionScrollSwiperWrapper.append(HourSwiperSlide);

        let HourSwiperSlideText = document.createElement("p");
        HourSwiperSlideText.className = "PaymentTimeText InterBoldTextFont";
        HourSwiperSlideText.textContent = i;
        HourSwiperSlide.append(HourSwiperSlideText);
    }

    let selectedHourBorder = document.createElement("div");
    selectedHourBorder.className = "SelectedTimeBorder";
    selectedHourBorder.innerHTML = `<div class="SelectedTimeUpSide"></div><div class="SelectedTimeDownSide"></div>`;
    HourSectionScrollContainer.append(selectedHourBorder);

    // === Divider Column ===
    let dividerCol = document.createElement("div");
    dividerCol.style.cssText = "width: fit-content; height: fit-content; position: relative; display: flex; flex-direction: column;";
    TimeScrollWrapper.append(dividerCol);

    let dividerHeaderContainer = document.createElement("div");
    dividerHeaderContainer.className = "PaymentTransferTypeHeaderContainer";
    dividerCol.append(dividerHeaderContainer);

    let dividerHeaderText = document.createElement("p");
    dividerHeaderText.className = "PaymentTransferTypeHeaderText InterMediumTextFont";
    dividerHeaderText.style.opacity = "0";
    dividerHeaderText.textContent = ":";
    dividerHeaderContainer.append(dividerHeaderText);

    let dividerWrapperParent = document.createElement("div");
    dividerWrapperParent.style.cssText = "width: fit-content; height: fit-content; position: relative;";
    dividerCol.append(dividerWrapperParent);

    let dividerWrapper = document.createElement("div");
    dividerWrapper.className = "PaymentHourAndMinutesDividerWrapper";
    dividerWrapperParent.append(dividerWrapper);

    let dividerP = document.createElement("p");
    dividerP.className = "PaymentTimeText InterRegularTextFont";
    dividerP.style.margin = "auto";
    dividerP.textContent = ":";
    dividerWrapper.append(dividerP);

    let dividerBorder = document.createElement("div");
    dividerBorder.className = "SelectedTimeBorder";
    dividerBorder.innerHTML = `<div class="SelectedTimeUpSide"></div><div class="SelectedTimeDownSide"></div>`;
    dividerWrapperParent.append(dividerBorder);

    // === Minutes Column ===
    let minCol = document.createElement("div");
    minCol.style.cssText = "width: fit-content; height: fit-content; position: relative; display: flex; flex-direction: column;";
    TimeScrollWrapper.append(minCol);

    let minHeaderContainer = document.createElement("div");
    minHeaderContainer.className = "PaymentTransferTypeHeaderContainer";
    minCol.append(minHeaderContainer);

    let minHeaderText = document.createElement("p");
    minHeaderText.className = "PaymentTransferTypeHeaderText InterMediumTextFont";
    minHeaderText.textContent = "Min";
    minHeaderContainer.append(minHeaderText);

    let minWrapperParent = document.createElement("div");
    minWrapperParent.style.cssText = "width: fit-content; height: fit-content; position: relative;";
    minCol.append(minWrapperParent);

    let minScrollParent = document.createElement("div");
    minScrollParent.className = "PaymentTransferTimeHourMinutesScrolParent";
    minWrapperParent.append(minScrollParent);

    let minScrollWrapper = document.createElement("div");
    minScrollWrapper.className = "PaymentTransferTimeHourMinutesScrolWrapper";
    minScrollParent.append(minScrollWrapper);

    let minSwiperWrapper = document.createElement("div");
    minSwiperWrapper.className = "swiper-wrapper";
    minScrollWrapper.append(minSwiperWrapper);

    for(let i = 0; i < 60; i++)
    {
        let minSlide = document.createElement("div");
        minSlide.className = "swiper-slide PaymentTimeScrollable";
        minSlide.setAttribute("min-value", i);
        minSwiperWrapper.append(minSlide);

        let minP = document.createElement("p");
        minP.className = "PaymentTimeText InterMediumTextFont";
        minP.textContent = i.toString().padStart(2, '0');
        minSlide.append(minP);
    }

    let minBorder = document.createElement("div");
    minBorder.className = "SelectedTimeBorder";
    minBorder.innerHTML = `<div class="SelectedTimeUpSide"></div><div class="SelectedTimeDownSide"></div>`;
    minWrapperParent.append(minBorder);

    // === AM/PM Column ===
    let ampmCol = document.createElement("div");
    ampmCol.style.cssText = "width: fit-content; height: fit-content; position: relative; display: flex; flex-direction: column;";
    TimeScrollWrapper.append(ampmCol);

    let ampmHeaderContainer = document.createElement("div");
    ampmHeaderContainer.className = "PaymentTransferTypeHeaderContainer";
    ampmCol.append(ampmHeaderContainer);

    let ampmHeaderText = document.createElement("p");
    ampmHeaderText.className = "PaymentTransferTypeHeaderText InterMediumTextFont";
    ampmHeaderText.textContent = "AM/PM";
    ampmHeaderContainer.append(ampmHeaderText);

    let ampmWrapperParent = document.createElement("div");
    ampmWrapperParent.style.cssText = "width: fit-content; height: fit-content; position: relative;";
    ampmCol.append(ampmWrapperParent);

    let ampmScrollParent = document.createElement("div");
    ampmScrollParent.className = "PaymentTransferTimeHourMinutesScrolParent";
    ampmScrollParent.style.display = "flex";
    ampmWrapperParent.append(ampmScrollParent);

    let ampmScroll = document.createElement("div");
    ampmScroll.className = "TransferTimeAMPMScroll";
    ampmScrollParent.append(ampmScroll);

    let ampmSwiperWrapper = document.createElement("div");
    ampmSwiperWrapper.className = "swiper-wrapper";
    ampmScroll.append(ampmSwiperWrapper);

    let CurrentAMPMIndex = 0;
    let AMPMList = ["AM","PM"];
    for(let i = 0; i < AMPMList.length; i++)
    {
        let ampmSlide = document.createElement("div");
        ampmSlide.className = "swiper-slide PaymentTimeScrollable";
        ampmSlide.setAttribute("ampm-value", AMPMList[i]);
        ampmSwiperWrapper.append(ampmSlide);

        let ampmP = document.createElement("p");
        ampmP.className = "PaymentTimeText InterRegularTextFont";
        ampmP.textContent = AMPMList[i];
        ampmSlide.append(ampmP);

        if(AMPMList[i] == CurrentAMPM)
        {
            CurrentAMPMIndex = i;
        }
    }

    let ampmBorder = document.createElement("div");
    ampmBorder.className = "SelectedTimeBorder";
    ampmBorder.innerHTML = `<div class="SelectedTimeUpSide"></div><div class="SelectedTimeDownSide"></div>`;
    ampmWrapperParent.append(ampmBorder);

    // ===== Apply Button =====
    let applyButtonContainer = document.createElement("div");
    applyButtonContainer.className = "ApplyButtonContainer";
    whitePanelContainer.append(applyButtonContainer);

    let pingNowButton = document.createElement("button");
    pingNowButton.className = "BasicTextButton BasicBoxShadow OrangeButton SignInButtonTop Selectable";
    pingNowButton.style.margin = "0 auto";
    pingNowButton.style.width = "85%";
    pingNowButton.textContent = "Ping Now";
    applyButtonContainer.append(pingNowButton);


    // SET SWIPER ==========================

    let SwiperHours = new window.Swiper(HourSectionScrollSwiperContainer,
    {
        direction: 'vertical',
        slidesPerView: 5,
        spaceBetween: 5,
        mousewheel: true,
        loop: true,
        observer: true,
        observeParents: true,
    });
    SwiperHours.slideTo(parseInt(CurrentHour) + 2);
    
    let SwiperMinutes = new window.Swiper(minScrollWrapper, {
        direction: 'vertical',
        slidesPerView: 5,
        spaceBetween: 5,
        mousewheel: true,
        loop: true,
        observer: true,
        observeParents: true,
    });
    SwiperMinutes.slideTo(parseInt(CurrentMinutes) + 3);

    let SwiperAMPM = new window.Swiper(ampmScroll,
    {
        direction: 'vertical',
        spaceBetween: 0,
        mousewheel: true,
        loop: false,
        observer: true,
        observeParents: true,
    });
    SwiperAMPM.slideTo(parseInt(CurrentAMPMIndex));

    let FunctionToCall = function()
    {
        ThisDropDownContainer.remove();
        functiontocall();
    }

    SwiperHours.on('slideChange', function ()
    {
        window.ChangeCurrentTime(SwiperHours, SwiperMinutes, SwiperAMPM, CurrentTimeText, pingNowButton, WhichVerifyTimeContainer, WhichVerifyText, ()=>FunctionToCall());
    });

    SwiperMinutes.on('slideChange', function ()
    {
        window.ChangeCurrentTime(SwiperHours, SwiperMinutes, SwiperAMPM, CurrentTimeText, pingNowButton, WhichVerifyTimeContainer, WhichVerifyText, ()=>FunctionToCall());
    });
    
    SwiperAMPM.on('slideChange', function()
    {
        window.ChangeCurrentTime(SwiperHours, SwiperMinutes, SwiperAMPM, CurrentTimeText, pingNowButton, WhichVerifyTimeContainer, WhichVerifyText, ()=>FunctionToCall());
    });

    window.ChangeCurrentTime(SwiperHours, SwiperMinutes, SwiperAMPM, CurrentTimeText, pingNowButton, WhichVerifyTimeContainer, WhichVerifyText, ()=>FunctionToCall());
}


window.ChangeCurrentTime = function(SwiperHours, SwiperMinutes, SwiperAMPM, CurrentTimeText, pingNowButton, WhichVerifyTimeContainer, WhichVerifyText, functiontocall)
{
    let HoursActiveSlide = SwiperHours.slides[SwiperHours.activeIndex + 2];
    let HourValue = HoursActiveSlide.getAttribute("hour-value");

    let MinutesActiveSlide = SwiperMinutes.slides[SwiperMinutes.activeIndex + 2];
    let MinutesValue = MinutesActiveSlide.getAttribute("min-value");

    let AMPMActiveSlide = SwiperAMPM.slides[SwiperAMPM.activeIndex];
    let AMPMValue = AMPMActiveSlide.getAttribute("ampm-value");

    let TextToDisplay = HourValue + ":" + MinutesValue.toString().padStart(2, "0") + " " + AMPMValue;

    CurrentTimeText.innerHTML = TextToDisplay;

    pingNowButton.onclick = function()
    {
        window.event.preventDefault();
        window.event.stopPropagation();

        WhichVerifyTimeContainer.setAttribute("hour-value", HourValue);
        WhichVerifyTimeContainer.setAttribute("min-value", MinutesValue);
        WhichVerifyTimeContainer.setAttribute("ampm-value", AMPMValue);

        if(WhichVerifyText.tagName  == "INPUT")
        {
            WhichVerifyText.value = TextToDisplay;
        }
        else
        {
            WhichVerifyText.innerHTML = TextToDisplay;
        }

        if(functiontocall != null) // Call Function After It ----------------------
        {
            if(typeof functiontocall === 'string')
            {
                eval(functiontocall);
            }
            else
            {
                functiontocall();
            }
        }
    }
}


// Prepare Calendar Cell ======================================================================

window.PreparePrevCurrentNextMonthCalendarInfo = function(year, month)
{
    const firstDay = new Date(year, month - 1, 1);
    const lastDay = new Date(year, month, 0);

    const firstWeekDay = firstDay.getDay(); // First Day Index (Sun = 0, Mon = 1, ...) of the Current Month
    const totalDays = lastDay.getDate(); // Total Day of the Current Month

    const cells = []; // Prepare an Array For Past, Current, Next Month Data -------------

    // Previous month ----------------------------------------------------------
    
    const prevMonthLastDay = new Date(year, month - 1, 0); // Last Day of the Previous Month
    const prevMonthDays = prevMonthLastDay.getDate(); // How Many Days Previous Month

    for(let i = firstWeekDay - 1; i >= 0; i--) // Get The Remaining Days for Previous Month Based On How Many Days (Last Month) - First Day Index (Current Month) 
    {
        const dayNumber = prevMonthDays - i;
        const date = new Date(year, month - 2, dayNumber);

        cells.push({
            date: window.formatDatetoString(date),
            day: dayNumber,
            datevalue: date,
            isOtherMonth: true // To Mark that This Data is Previous Month
        });
    }

    // Current month ----------------------------------------------------------

    for(let day = 1; day <= totalDays; day++)
    {
        const date = new Date(year, month - 1, day);

        cells.push({
            date: window.formatDatetoString(date),
            day,
            datevalue: date,
            isOtherMonth: false  // To Mark that This Data is Current Month
        });
    }

    // Fill last row ----------------------------------------------------------

    // const remainder = cells.length % 7; // Get the Remainder Using %, which is the last cells of the last array from current date

    // if(remainder > 0)
    // {
    //     const needed = 7 - remainder; // How Many Needed to Fully Cover the Remaining Cells

    //     for(let day = 1; day <= needed; day++)
    //     {
    //         const date = new Date(year, month, day);

    //         cells.push({
    //             date: window.formatDatetoString(date),
    //             day,
    //             datevalue: date,
    //             isOtherMonth: true
    //         });
    //     }
    // }


    const TOTAL_CELLS = 42;

    while (cells.length < TOTAL_CELLS)
    {
        const nextDay = cells.length - (firstWeekDay + totalDays) + 1;

        const date = new Date(year, month, nextDay);

        cells.push({
            date: window.formatDatetoString(date),
            day: nextDay,
            datevalue: date,
            isOtherMonth: true
        });
    }

    return cells;
}

